import React__default, { forwardRef, useState, useCallback, createElement, useEffect, createContext, useContext, useRef } from 'react';
import { Link, useLocation, Route } from 'react-router-dom';
import baseStyled, { css as css$1, createGlobalStyle, keyframes } from 'styled-components';
import reset from 'styled-reset';
import { createBrowserHistory } from 'history';
import { store } from 'react-notifications-component';
import { useIndexedDB } from 'react-indexed-db';
import OutsideClickHandler from 'react-outside-click-handler';
import 'react-datepicker/dist/react-datepicker.css';
import Pickr from 'react-datepicker';
import { Helmet } from 'react-helmet';
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';
import jwt_decode from 'jwt-decode';
import { WebAuth } from 'auth0-js';
import { useCookies } from 'react-cookie';
import Select from 'react-select';
import TagsInput from 'react-tagsinput';
import moment from 'moment';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}

// Wrap styled type with our Theme. This makes it so that typescript can
// introspect our Theme type
var styled = baseStyled;
var css = css$1;

var GlobalStyles = createGlobalStyle(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  \n  *, ::after, ::before {\n    box-sizing: border-box;\n  }\n\n  html {\n    font-family: ", ";\n    font-weight: ", ";\n    font-size: 87.5% /* 14px */;\n    color: ", ";\n    height: 100%;\n  }\n\n  body {\n    ", ";\n    line-height: 1.3;\n  }\n\n  strong {\n    font-weight: 500;\n  }\n\n  .mb-icon {\n    vertical-align: middle;\n  }\n"], ["\n  ", "\n  \n  *, ::after, ::before {\n    box-sizing: border-box;\n  }\n\n  html {\n    font-family: ",
    ";\n    font-weight: ", ";\n    font-size: 87.5% /* 14px */;\n    color: ", ";\n    height: 100%;\n  }\n\n  body {\n    ",
    ";\n    line-height: 1.3;\n  }\n\n  strong {\n    font-weight: 500;\n  }\n\n  .mb-icon {\n    vertical-align: middle;\n  }\n"])), reset, function (_a) {
    var theme = _a.theme;
    return "" + theme.fonts.family.sans;
}, function (_a) {
    var theme = _a.theme;
    return theme.fonts.weights.normal;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.gray['700'];
}, function (_a) {
    var withGradient = _a.withGradient, theme = _a.theme;
    return withGradient
        ? "\n      background: linear-gradient(\n        1.16deg,\n        " + theme.colors.pink['500'] + " -126.16%,\n        " + theme.colors.purple['500'] + " 94.08%\n      );\n      "
        : "\n        background: " + theme.colors.coolGray['50'] + "; \n    ";
});
var templateObject_1;

/**
 * Define the theme and its types, to be used with styled-components
 */
var colors = {
    primary: '#D92982',
    secondary: '#330066',
    transparent: 'transparent',
    black: '#000000',
    white: '#FFFFFF',
    gray: {
        '50': '#f9fafb',
        '100': '#f4f5f7',
        '200': '#e5e7eb',
        '300': '#d2d6dc',
        '400': '#9fa6b2',
        '500': '#6b7280',
        '600': '#4b5563',
        '700': '#374151',
        '800': '#252f3f',
        '900': '#161e2e',
    },
    coolGray: {
        '50': '#fbfdfe',
        '100': '#f1f5f9',
        '200': '#e2e8f0',
        '300': '#cfd8e3',
        '400': '#97a6ba',
        '500': '#64748b',
        '600': '#475569',
        '700': '#364152',
        '800': '#27303f',
        '900': '#1a202e',
    },
    red: {
        '50': '#fdf2f2',
        '100': '#fde8e8',
        '200': '#fbd5d5',
        '300': '#f8b4b4',
        '400': '#f98080',
        '500': '#f05252',
        '600': '#e02424',
        '700': '#c81e1e',
        '800': '#9b1c1c',
        '900': '#771d1d',
    },
    orange: {
        '50': '#fff8f1',
        '100': '#feecdc',
        '200': '#fcd9bd',
        '300': '#fdba8c',
        '400': '#ff8a4c',
        '500': '#ff5a1f',
        '600': '#d03801',
        '700': '#b43403',
        '800': '#8a2c0d',
        '900': '#771d1d',
    },
    yellow: {
        '50': '#fdfdea',
        '100': '#fdf6b2',
        '200': '#fce96a',
        '300': '#faca15',
        '400': '#e3a008',
        '500': '#c27803',
        '600': '#9f580a',
        '700': '#8e4b10',
        '800': '#723b13',
        '900': '#633112',
    },
    green: {
        '50': '#f3faf7',
        '100': '#def7ec',
        '200': '#bcf0da',
        '300': '#84e1bc',
        '400': '#31c48d',
        '500': '#0e9f6e',
        '600': '#057a55',
        '700': '#046c4e',
        '800': '#03543f',
        '900': '#014737',
    },
    teal: {
        '50': '#edfafa',
        '100': '#d5f5f6',
        '200': '#afecef',
        '300': '#7edce2',
        '400': '#16bdca',
        '500': '#0694a2',
        '600': '#047481',
        '700': '#036672',
        '800': '#05505c',
        '900': '#014451',
    },
    blue: {
        '50': '#ebf5ff',
        '100': '#e1effe',
        '200': '#c3ddfd',
        '300': '#a4cafe',
        '400': '#76a9fa',
        '500': '#3f83f8',
        '600': '#1c64f2',
        '700': '#1a56db',
        '800': '#1e429f',
        '900': '#233876',
    },
    indigo: {
        '50': '#f0f5ff',
        '100': '#e5edff',
        '200': '#cddbfe',
        '300': '#b4c6fc',
        '400': '#8da2fb',
        '500': '#6875f5',
        '600': '#5850ec',
        '700': '#5145cd',
        '800': '#42389d',
        '900': '#362f78',
    },
    purple: {
        '100': '#EBE6F0',
        '200': '#CCBFD9',
        '300': '#AD99C2',
        '400': '#704D94',
        '500': '#330066',
        '600': '#2E005C',
        '700': '#1F003D',
        '800': '#17002E',
        '900': '#0F001F',
    },
    pink: {
        '100': '#FBEAF3',
        '200': '#F6CAE0',
        '300': '#F0A9CD',
        '400': '#E469A8',
        '500': '#D92982',
        '600': '#C32575',
        '700': '#82194E',
        '800': '#62123B',
        '900': '#410C27',
    },
};
var borderRadius = {
    none: '0',
    sm: '0.125rem',
    default: '0.25rem',
    md: '0.375rem',
    lg: '0.5rem',
    full: '9999px',
};
var boxShadow = {
    sm: '0 1px 2px 0 rgba(0, 0, 0, 0.04)',
    default: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
    md: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
    lg: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
    xl: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
    '2xl': '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
    inner: 'inset 0 2px 4px 0 rgba(0, 0, 0, 0.06)',
    outline: '0 0 0 3px rgba(66, 153, 225, 0.5)',
    none: 'none',
};
var flex = {
    '1': '1 1 0%',
    auto: '1 1 auto',
    initial: '0 1 auto',
    none: 'none',
};
var flexGrow = {
    '0': '0',
    default: '1',
};
var flexShrink = {
    '0': '0',
    default: '1',
};
var fonts = {
    family: {
        sans: [
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            '"Noto Sans"',
            'sans-serif',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
            '"Noto Color Emoji"',
        ],
        serif: ['Georgia', 'Cambria', '"Times New Roman"', 'Times', 'serif'],
        mono: [
            'Menlo',
            'Monaco',
            'Consolas',
            '"Liberation Mono"',
            '"Courier New"',
            'monospace',
        ],
    },
    weights: {
        hairline: '100',
        thin: '200',
        light: '300',
        normal: '400',
        medium: '500',
        semibold: '600',
        bold: '700',
        extrabold: '800',
        black: '900',
    },
    size: {
        xs: '0.75rem',
        sm: '0.875rem',
        base: '1rem',
        lg: '1.125rem',
        xl: '1.25rem',
        '2xl': '1.5rem',
        '3xl': '1.875rem',
        '4xl': '2.25rem',
        '5xl': '3rem',
        '6xl': '4rem',
    },
};
var headings = {
    level: {
        1: {
            size: fonts.size['3xl'],
        },
        2: {
            size: fonts.size['2xl'],
        },
        3: {
            size: fonts.size.xl,
        },
        4: {
            size: fonts.size.lg,
        },
        5: {
            size: fonts.size.base,
        },
        6: {
            size: fonts.size.sm,
        },
    },
};
var height = {
    auto: 'auto',
    full: '100%',
    screen: '100vh',
};
var lineHeight = {
    none: '1',
    tight: '1.25',
    snug: '1.375',
    normal: '1.5',
    relaxed: '1.625',
    loose: '2',
};
var screens = {
    sm: '640px',
    md: '768px',
    lg: '1024px',
    xl: '1280px',
};
var spacing = {
    px: '1px',
    '0': '0',
    '1': '0.25rem',
    '2': '0.5rem',
    '3': '0.75rem',
    '4': '1rem',
    '5': '1.25rem',
    '6': '1.5rem',
    '7': '1.75rem',
    '8': '2rem',
    '10': '2.5rem',
    '12': '3rem',
    '16': '4rem',
    '20': '5rem',
    '24': '6rem',
    '32': '8rem',
    '40': '10rem',
    '48': '12rem',
    '56': '14rem',
    '64': '16rem',
};
var width = {
    auto: 'auto',
    '1/2': '50%',
    '1/3': '33.333333%',
    '2/3': '66.666667%',
    '1/4': '25%',
    '2/4': '50%',
    '3/4': '75%',
    '1/5': '20%',
    '2/5': '40%',
    '3/5': '60%',
    '4/5': '80%',
    '1/6': '16.666667%',
    '2/6': '33.333333%',
    '3/6': '50%',
    '4/6': '66.666667%',
    '5/6': '83.333333%',
    '1/12': '8.333333%',
    '2/12': '16.666667%',
    '3/12': '25%',
    '4/12': '33.333333%',
    '5/12': '41.666667%',
    '6/12': '50%',
    '7/12': '58.333333%',
    '8/12': '66.666667%',
    '9/12': '75%',
    '10/12': '83.333333%',
    '11/12': '91.666667%',
    full: '100%',
    screen: '100vw',
};
var theme = {
    colors: colors,
    borderRadius: borderRadius,
    boxShadow: boxShadow,
    flex: flex,
    flexGrow: flexGrow,
    flexShrink: flexShrink,
    fonts: fonts,
    headings: headings,
    height: height,
    lineHeight: lineHeight,
    screens: screens,
    spacing: spacing,
    width: width,
};

var deviceMapping = [
    ['phone', 639, undefined],
    ['tablet', 767, 640],
    ['notebook', 1023, 768],
    ['desktop', 1279, 1024],
    ['hd', undefined, 1280],
];
var mq = function (max) { return function (first) {
    var interpolations = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        interpolations[_i - 1] = arguments[_i];
    }
    return css$1(templateObject_1$1 || (templateObject_1$1 = __makeTemplateObject(["\n    @media screen and (max-width: ", "px) {\n      ", "\n    }\n  "], ["\n    @media screen and (max-width: ", "px) {\n      ", "\n    }\n  "])), max, css$1.apply(void 0, __spreadArrays([first], interpolations)));
}; };
var devices = deviceMapping.reduce(function (d, r) {
    d[r[0]] = mq(r[1]);
    return d;
}, {});
var templateObject_1$1;

var normaliseColor = function (data) {
    var colorHex;
    var colorName = data.split('-');
    var color = colorName[0];
    if (colorName.length === 1) {
        colorHex = theme.colors[color] || colorName;
    }
    else {
        var shade = colorName[1];
        colorHex = theme.colors[color][shade];
    }
    return colorHex;
};

var colors$1 = function (colors) { return keyframes(templateObject_1$2 || (templateObject_1$2 = __makeTemplateObject(["\n\t0% { stroke: ", "; }\n  100% { stroke: ", "; }\n"], ["\n\t0% { stroke: ", "; }\n  100% { stroke: ", "; }\n"])), normaliseColor(colors.first), normaliseColor(colors.second)); };
var rotator = keyframes(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(270deg); }\n"], ["\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(270deg); }\n"])));
var offset = 187;
var dash = keyframes(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  0% { stroke-dashoffset: ", "; }\n  50% {\n    stroke-dashoffset: ", ";\n    transform:rotate(135deg);\n  }\n  100% {\n    stroke-dashoffset: ", ";\n    transform:rotate(450deg);\n  }\n"], ["\n  0% { stroke-dashoffset: ", "; }\n  50% {\n    stroke-dashoffset: ", ";\n    transform:rotate(135deg);\n  }\n  100% {\n    stroke-dashoffset: ", ";\n    transform:rotate(450deg);\n  }\n"])), offset, offset / 4, offset);
var fadeIn = keyframes(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  from { opacity: 0; }\n  to   { opacity: 1; }\n"], ["\n  from { opacity: 0; }\n  to   { opacity: 1; }\n"])));
var templateObject_1$2, templateObject_2, templateObject_3, templateObject_4;

var borderStyle = function (data) {
    var styles = [];
    var color = normaliseColor(data.color || 'coolGray-200');
    var borderSize = data.size || '1px';
    var style = data.style || 'solid';
    var side = typeof data === 'string' ? data : data.side || 'all';
    var value = style + " " + borderSize + " " + color;
    if (side === 'top' ||
        side === 'bottom' ||
        side === 'left' ||
        side === 'right') {
        styles.push("border-" + side + ": " + value + ";");
    }
    else if (side === 'vertical') {
        styles.push("\n      border-left: " + value + ";\n      border-right: " + value + ";\n    ");
    }
    else if (side === 'horizontal') {
        styles.push("\n      border-top: " + value + ";\n      border-bottom: " + value + ";\n    ");
    }
    else {
        styles.push("\n        border: " + value + ";\n      ");
    }
    return styles;
};

var backgroundStyle = function (background) {
    if (typeof background === 'object') {
        var styles = [];
        if (background.image) {
            styles.push(css$1(templateObject_1$3 || (templateObject_1$3 = __makeTemplateObject(["\n        background-image: ", ";\n        background-repeat: ", ";\n        background-position: ", ";\n        background-size: ", ";\n      "], ["\n        background-image: ", ";\n        background-repeat: ", ";\n        background-position: ", ";\n        background-size: ", ";\n      "])), background.image, background.repeat || 'no-repeat', background.position || 'center center', background.size || 'cover'));
        }
        if (background.color) {
            var color = normaliseColor(background.color);
            styles.push(css$1(templateObject_2$1 || (templateObject_2$1 = __makeTemplateObject(["\n        background-color: ", ";\n      "], ["\n        background-color: ", ";\n      "])), color));
        }
        if (background.gradient) {
            styles.push(css$1(templateObject_3$1 || (templateObject_3$1 = __makeTemplateObject(["\n        background: linear-gradient(\n          ", ",\n          ", "\n            ", "%,\n          ", " ", "%\n        );\n      "], ["\n        background: linear-gradient(\n          ", ",\n          ", "\n            ", "%,\n          ", " ", "%\n        );\n      "])), background.angle, normaliseColor(background.start.color), background.start.position, normaliseColor(background.end.color), background.end.position));
        }
        return styles;
    }
    if (background) {
        if (background.lastIndexOf('url', 0) === 0) {
            return css$1(templateObject_4$1 || (templateObject_4$1 = __makeTemplateObject(["\n        background: ", " no-repeat center center;\n        background-size: cover;\n      "], ["\n        background: ", " no-repeat center center;\n        background-size: cover;\n      "])), background);
        }
        var backgroundColor = normaliseColor(background);
        if (backgroundColor) {
            return css$1(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n        background: ", ";\n      "], ["\n        background: ", ";\n      "])), backgroundColor);
        }
    }
    return undefined;
};
var templateObject_1$3, templateObject_2$1, templateObject_3$1, templateObject_4$1, templateObject_5;

var friendlyDates = {
    sameDay: '[Today -] ha',
    nextDay: '[Tomorrow -] ha',
    nextWeek: 'DD MMM YYYY [-] ha',
    lastDay: '[Yesterday -] ha',
    lastWeek: 'DD MMM YYYY [-] ha',
    sameElse: 'DD MMM YYYY [-] ha',
};
var friendlyDatesFullTime = {
    sameDay: '[Today -] HH:mm',
    nextDay: '[Tomorrow -] HH:mm',
    nextWeek: 'DD MMM YYYY [-] HH:mm',
    lastDay: '[Yesterday -] HH:mm',
    lastWeek: 'DD MMM YYYY [-] HH:mm',
    sameElse: 'DD MMM YYYY [-] HH:mm',
};
var friendlyDatesNoTime = {
    sameDay: '[Today]',
    nextDay: '[Tomorrow]',
    nextWeek: 'DD MMM YYYY',
    lastDay: '[Yesterday]',
    lastWeek: 'DD MMM YYYY',
    sameElse: 'DD MMM YYYY',
};

var gapStyle = function (type, data) {
    if (typeof data === 'string') {
        return css$1(templateObject_1$4 || (templateObject_1$4 = __makeTemplateObject(["\n      ", ": ", ";\n    "], ["\n      ", ": ", ";\n    "])), type, function (_a) {
            var theme = _a.theme;
            return theme.spacing[data] || data;
        });
    }
    var result = [];
    if (data.horizontal) {
        result.push(css$1(templateObject_2$2 || (templateObject_2$2 = __makeTemplateObject(["\n      ", "-left: ", ";\n      ", "-right: ", ";\n    "], ["\n      ", "-left: ",
            ";\n      ", "-right: ",
            ";\n    "])), type, function (_a) {
            var theme = _a.theme;
            return theme.spacing[data.horizontal] || data.horizontal;
        }, type, function (_a) {
            var theme = _a.theme;
            return theme.spacing[data.horizontal] || data.horizontal;
        }));
    }
    if (data.vertical) {
        result.push(css$1(templateObject_3$2 || (templateObject_3$2 = __makeTemplateObject(["\n      ", "-top: ", ";\n      ", "-bottom: ", ";\n    "], ["\n      ", "-top: ",
            ";\n      ", "-bottom: ",
            ";\n    "])), type, function (_a) {
            var theme = _a.theme;
            return theme.spacing[data.vertical] || data.vertical;
        }, type, function (_a) {
            var theme = _a.theme;
            return theme.spacing[data.vertical] || data.vertical;
        }));
    }
    if (data.top) {
        result.push(css$1(templateObject_4$2 || (templateObject_4$2 = __makeTemplateObject(["\n      ", "-top: ", ";\n    "], ["\n      ", "-top: ", ";\n    "])), type, function (_a) {
            var theme = _a.theme;
            return theme.spacing[data.top] || data.top;
        }));
    }
    if (data.bottom) {
        result.push(css$1(templateObject_5$1 || (templateObject_5$1 = __makeTemplateObject(["\n      ", "-bottom: ", ";\n    "], ["\n      ", "-bottom: ",
            ";\n    "])), type, function (_a) {
            var theme = _a.theme;
            return theme.spacing[data.bottom] || data.bottom;
        }));
    }
    if (data.left) {
        result.push(css$1(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      ", "-left: ", ";\n    "], ["\n      ", "-left: ", ";\n    "])), type, function (_a) {
            var theme = _a.theme;
            return theme.spacing[data.left] || data.left;
        }));
    }
    if (data.right) {
        result.push(css$1(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n      ", "-right: ", ";\n    "], ["\n      ", "-right: ", ";\n    "])), type, function (_a) {
            var theme = _a.theme;
            return theme.spacing[data.right] || data.right;
        }));
    }
    return result;
};
var templateObject_1$4, templateObject_2$2, templateObject_3$2, templateObject_4$2, templateObject_5$1, templateObject_6, templateObject_7;

var history = createBrowserHistory();

var overflowStyle = function (data) {
    if (typeof data === 'string') {
        return css$1(templateObject_1$5 || (templateObject_1$5 = __makeTemplateObject(["\n      overflow: ", ";\n    "], ["\n      overflow: ", ";\n    "])), data);
    }
    return css$1(templateObject_2$3 || (templateObject_2$3 = __makeTemplateObject(["\n    ", "\n    ", ";\n  "], ["\n    ", "\n    ", ";\n  "])), data.horizontal && "overflow-x: " + data.horizontal + ";", data.vertical && "overflow-y: " + data.vertical + ";");
};
var templateObject_1$5, templateObject_2$3;

var radiusStyle = function (data) {
    return css$1(templateObject_1$6 || (templateObject_1$6 = __makeTemplateObject(["\n    border-radius: ", ";\n  "], ["\n    border-radius: ", ";\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.borderRadius[data] || data;
    });
};
var templateObject_1$6;

var internalImageHosts = [
    'users-images-atlas.metabroadcast.com',
    'users-images-stage-atlas.metabroadcast.com',
    'images.metabroadcast.com',
];
var resizeImage = function (url, options) {
    if (options === void 0) { options = {}; }
    var resizerUrl = url;
    if (!internalImageHosts.some(function (host) { return url.includes(host); })) {
        resizerUrl = "https://images.metabroadcast.com/?source=" + encodeURIComponent(url);
    }
    Object.keys(options).forEach(function (parameter) {
        resizerUrl += "&" + parameter + "=" + encodeURIComponent(options[parameter]);
    });
    return resizerUrl;
};

var shadowStyle = function (shadowSize) {
    return css$1(templateObject_1$7 || (templateObject_1$7 = __makeTemplateObject(["\n    box-shadow: ", ";\n  "], ["\n    box-shadow: ", ";\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.boxShadow[shadowSize];
    });
};
var templateObject_1$7;

var weightStyle = function (data) {
    return css$1(templateObject_1$8 || (templateObject_1$8 = __makeTemplateObject(["\n    font-weight: ", ";\n  "], ["\n    font-weight: ", ";\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.fonts.weights[data] || data;
    });
};
var templateObject_1$8;

var sendNotification = function (_a) {
    var message = _a.message, _b = _a.type, type = _b === void 0 ? 'success' : _b, _c = _a.insert, insert = _c === void 0 ? 'top' : _c, _d = _a.container, container = _d === void 0 ? 'top-center' : _d, _e = _a.animationIn, animationIn = _e === void 0 ? ['animated', 'fadeInDown'] : _e, _f = _a.animationOut, animationOut = _f === void 0 ? ['animated', 'fadeOut'] : _f, _g = _a.dismiss, dismiss = _g === void 0 ? {
        duration: 2000,
    } : _g;
    store.addNotification({
        message: message,
        type: type,
        insert: insert,
        container: container,
        animationIn: animationIn,
        animationOut: animationOut,
        dismiss: dismiss,
    });
};

var hashstr = function (s) {
    var hash = 0;
    if (s.length === 0)
        return hash;
    for (var i = 0; i < s.length; i++) {
        var char = s.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash = hash & hash; // Convert to 32bit integer
    }
    return hash;
};
var CachedFetch = function (url, options) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, add, deleteRecord, getByIndex, expiry, cacheKey, cached, whenCached, age, response;
    var _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _a = useIndexedDB('api_responses'), add = _a.add, deleteRecord = _a.deleteRecord, getByIndex = _a.getByIndex;
                expiry = 3600;
                if (typeof options === 'number') {
                    expiry = options;
                    options = undefined;
                }
                else if (typeof options === 'object') {
                    // I hope you didn't set it to 0 seconds
                    expiry = options.seconds || expiry;
                }
                cacheKey = hashstr(url);
                return [4 /*yield*/, getByIndex('path', cacheKey)];
            case 1:
                cached = _c.sent();
                whenCached = (_b = cached) === null || _b === void 0 ? void 0 : _b.ts;
                if (cached !== null && whenCached !== null) {
                    age = (Date.now() - whenCached) / 1000;
                    if (age < expiry) {
                        response = new Response(new Blob([cached.data]));
                        return [2 /*return*/, Promise.resolve(response)];
                    }
                    else {
                        // We need to clean up this old key
                        deleteRecord(cacheKey);
                    }
                }
                return [2 /*return*/, fetch(url, options).then(function (response) {
                        // let's only store in cache if the content-type is
                        // JSON or something non-binary
                        if (response.status === 200) {
                            var ct = response.headers.get('Content-Type');
                            if (ct && (ct.match(/application\/json/i) || ct.match(/text\//i))) {
                                // There is a .json() instead of .text() but
                                // we're going to store it in sessionStorage as
                                // string anyway.
                                // If we don't clone the response, it will be
                                // consumed by the time it's returned. This
                                // way we're being un-intrusive.
                                response
                                    .clone()
                                    .text()
                                    .then(function (content) {
                                    add({
                                        ts: Date.now(),
                                        data: content,
                                        path: cacheKey,
                                    });
                                });
                            }
                        }
                        return response;
                    })];
        }
    });
}); };

var StyledA = styled(Link)(templateObject_1$9 || (templateObject_1$9 = __makeTemplateObject(["\n  ", "\n  ", "\n  text-decoration: none;\n"], ["\n  ", "\n  ", "\n  text-decoration: none;\n"])), function (props) { return "color: " + normaliseColor(props.color) + ";"; }, function (props) { return weightStyle(props.weight); });
var templateObject_1$9;

var A = function (_a) {
    var weight = _a.weight, color = _a.color, rest = __rest(_a, ["weight", "color"]);
    return React__default.createElement(StyledA, __assign({}, rest, { color: color, weight: weight }));
};
A.defaultProps = {
    color: 'primary',
    weight: 'normal',
};

var StyledInputWrapper = styled.div(templateObject_1$a || (templateObject_1$a = __makeTemplateObject(["\n  position: relative;\n  width: 100%;\n  ", ";\n  max-width: ", "};\n  ", ";\n  ", ";\n"], ["\n  position: relative;\n  width: 100%;\n  ", ";\n  max-width: ",
    "};\n  ", ";\n  ", ";\n"])), function (props) { return props.flex && "flex: " + props.flex; }, function (props) {
    return (props.widthProp && props.theme.width[props.widthProp]) ||
        props.widthProp;
}, function (props) { return props.padding && gapStyle('padding', props.padding); }, function (props) { return props.margin && gapStyle('margin', props.margin); });
var StyledInput = styled.input(templateObject_2$4 || (templateObject_2$4 = __makeTemplateObject(["\n  width: 100%;\n  outline: none;\n  ", "\n  background: ", ";\n  color: ", ";\n  font-size: ", ";\n  border: 1px solid;\n  border-color: transparent;\n  ", "\n  box-shadow: 0 0 0 0 transparent;\n  transition: border-color 0.3s ease, box-shadow 0.3s ease;\n\n  &:focus {\n    box-shadow: 0 0 0 3px ", ";\n    border-color: ", ";\n  }\n\n  &::placeholder {\n    color: ", ";\n  }\n"], ["\n  width: 100%;\n  outline: none;\n  ",
    "\n  background: ", ";\n  color: ", ";\n  font-size: ", ";\n  border: 1px solid;\n  border-color: transparent;\n  ", "\n  box-shadow: 0 0 0 0 transparent;\n  transition: border-color 0.3s ease, box-shadow 0.3s ease;\n\n  &:focus {\n    box-shadow: 0 0 0 3px ", ";\n    border-color: ", ";\n  }\n\n  &::placeholder {\n    color: ", ";\n  }\n"])), gapStyle('padding', {
    horizontal: '4',
    vertical: '3',
}), function (_a) {
    var background = _a.background;
    return normaliseColor(background);
}, normaliseColor('coolGray-700'), function (_a) {
    var theme = _a.theme;
    return theme.fonts.size.base;
}, function (props) { return props.radiusProp && radiusStyle(props.radiusProp); }, normaliseColor('pink-100'), function (props) { return normaliseColor(props.highlight); }, normaliseColor('coolGray-400'));
var templateObject_1$a, templateObject_2$4;

var StyledLabel = styled.label(templateObject_1$b || (templateObject_1$b = __makeTemplateObject(["\n  display: inline-block;\n  font-size: ", ";\n  ", "\n  ", "\n  ", "\n"], ["\n  display: inline-block;\n  font-size: ", ";\n  ", "\n  ", "\n  ", "\n"])), function (props) { return props.theme.fonts.size[props.sizeProp]; }, function (props) { return "color: " + normaliseColor(props.colorProp) + ";"; }, function (props) { return weightStyle(props.weight); }, function (props) { return props.marginProp && gapStyle('margin', props.marginProp); });
var templateObject_1$b;

var Label = function (_a) {
    var _b = _a.color, color = _b === void 0 ? 'coolGray-700' : _b, _c = _a.size, size = _c === void 0 ? 'base' : _c, _d = _a.weight, weight = _d === void 0 ? 'medium' : _d, _e = _a.margin, margin = _e === void 0 ? '0' : _e, rest = __rest(_a, ["color", "size", "weight", "margin"]);
    return (React__default.createElement(StyledLabel, __assign({}, rest, { colorProp: color, sizeProp: size, weight: weight, marginProp: margin })));
};

var TextInput = forwardRef(function (_a, _ref) {
    var _b = _a.type, type = _b === void 0 ? 'text' : _b, _c = _a.radius, radius = _c === void 0 ? 'default' : _c, _d = _a.background, background = _d === void 0 ? 'coolGray-100' : _d, label = _a.label, padding = _a.padding, margin = _a.margin, _e = _a.width, width = _e === void 0 ? 'full' : _e, _f = _a.highlight, highlight = _f === void 0 ? 'pink-500' : _f, readOnly = _a.readOnly, onChange = _a.onChange, onClick = _a.onClick, onKeyDown = _a.onKeyDown, onFocus = _a.onFocus, onBlur = _a.onBlur, defaultValue = _a.defaultValue, rest = __rest(_a, ["type", "radius", "background", "label", "padding", "margin", "width", "highlight", "readOnly", "onChange", "onClick", "onKeyDown", "onFocus", "onBlur", "defaultValue"]);
    return (React__default.createElement(StyledInputWrapper, { padding: padding, margin: margin, widthProp: width },
        label && (React__default.createElement(Label, { color: "coolGray-700", weight: "medium", margin: { bottom: '2' } }, label)),
        React__default.createElement(StyledInput, __assign({ type: type, ref: _ref, background: background, radiusProp: radius, highlight: highlight, readOnly: readOnly, onChange: onChange, onClick: onClick, onKeyDown: onKeyDown, onFocus: onFocus, onBlur: onBlur, defaultValue: defaultValue }, rest))));
});

var ALIGN_MAP = {
    baseline: 'baseline',
    center: 'center',
    end: 'flex-end',
    start: 'flex-start',
    stretch: 'stretch',
};
var ALIGN_CONTENT_MAP = {
    around: 'around',
    between: 'between',
    center: 'center',
    end: 'flex-end',
    start: 'flex-start',
    stretch: 'stretch',
};
var BASIS_MAP = {
    auto: 'auto',
    full: '100%',
    '1/2': '50%',
    '1/4': '25%',
    '2/4': '50%',
    '3/4': '75%',
    '1/3': '33.33%',
    '2/3': '66.66%',
};
var JUSTIFY_MAP = {
    around: 'space-around',
    between: 'space-between',
    center: 'center',
    end: 'flex-end',
    evenly: 'space-evenly',
    start: 'flex-start',
};
var FLEX_MAP = {
    full: '1 1',
    none: '0 0',
    grow: '1 0',
    shrink: '0 1',
};
var directionStyle = css(templateObject_1$c || (templateObject_1$c = __makeTemplateObject(["\n  ", "\n  ", "\n  flex-direction: ", ";\n"], ["\n  ", "\n  ", "\n  flex-direction: ", ";\n"])), function (props) { return !props.widthProp && "min-width: auto;"; }, function (props) { return !props.heightProp && "min-height: auto;"; }, function (props) { return props.directionProp; });
var fillStyle = function (fillProp) {
    if (fillProp === 'horizontal') {
        return 'width: 100%;';
    }
    if (fillProp === 'vertical') {
        return 'height: 100%;';
    }
    if (fillProp) {
        return "\n      width: 100%;\n      height: 100%;\n    ";
    }
    return undefined;
};
var sizeStyle = function (type, size) {
    if (typeof size === 'string') {
        return css(templateObject_2$5 || (templateObject_2$5 = __makeTemplateObject(["\n      ", ": ", ";\n    "], ["\n      ", ": ", ";\n    "])), type, function (_a) {
            var theme = _a.theme;
            return theme[type][size] || size;
        });
    }
    var sizes = [];
    if (size.base) {
        sizes.push(css(templateObject_3$3 || (templateObject_3$3 = __makeTemplateObject(["\n      ", ": ", ";\n    "], ["\n      ", ": ", ";\n    "])), type, function (_a) {
            var theme = _a.theme;
            return theme[type][size.base] || size.base;
        }));
    }
    if (size.max) {
        sizes.push(css(templateObject_4$3 || (templateObject_4$3 = __makeTemplateObject(["\n      max-", ": ", ";\n    "], ["\n      max-", ": ", ";\n    "])), type, function (_a) {
            var theme = _a.theme;
            return theme[type][size.max] || size.max;
        }));
    }
    if (size.min) {
        sizes.push(css(templateObject_5$2 || (templateObject_5$2 = __makeTemplateObject(["\n      min-", ": ", ";\n    "], ["\n      min-", ": ", ";\n    "])), type, function (_a) {
            var theme = _a.theme;
            return theme[type][size.min] || size.min;
        }));
    }
    return sizes;
};
var flexGrowShrinkProp = function (flex) {
    if (typeof flex === 'boolean' || typeof flex === 'string') {
        if (typeof flex === 'boolean') {
            flex = flex ? 'full' : 'none';
        }
        return FLEX_MAP[flex] || flex;
    }
    return (flex.grow ? flex.grow : 0) + " " + (flex.shrink ? flex.shrink : 0);
};
var flexStyle = css(templateObject_6$1 || (templateObject_6$1 = __makeTemplateObject(["\n  flex: ", ";\n"], ["\n  flex: ",
    ";\n"])), function (props) {
    return "" + flexGrowShrinkProp(props.flex) + (props.flex !== true && !props.basis ? ' auto' : '');
});
var stickyStyle = css(templateObject_7$1 || (templateObject_7$1 = __makeTemplateObject(["\n  position: sticky;\n  top: 0;\n"], ["\n  position: sticky;\n  top: 0;\n"])));
var BoxWrap = styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  display: flex;\n  box-sizing: border-box;\n  outline: none;\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", ";\n  ", "\n  ", "\n    ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"], ["\n  display: flex;\n  box-sizing: border-box;\n  outline: none;\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ",
    "\n  ", "\n  ",
    "\n  ", ";\n  ", "\n  ", "\n    ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), function (props) { return props.directionProp && directionStyle; }, function (props) { return props.sticky !== undefined && stickyStyle; }, function (props) { return props.widthProp && sizeStyle('width', props.widthProp); }, function (props) { return props.heightProp && sizeStyle('height', props.heightProp); }, function (props) { return props.margin && gapStyle('margin', props.margin); }, function (props) { return props.padding && gapStyle('padding', props.padding); }, function (props) { return props.align && "align-items: " + ALIGN_MAP[props.align] + ";"; }, function (props) { return props.flex !== undefined && flexStyle; }, function (props) {
    return props.alignContent &&
        "align-content: " + ALIGN_CONTENT_MAP[props.alignContent] + ";";
}, function (props) { return props.justify && "justify-content: " + JUSTIFY_MAP[props.justify] + ";"; }, function (props) {
    return props.basis && "flex-basis: " + (BASIS_MAP[props.basis] || props.basis) + ";";
}, function (props) { return (props.wrapProp ? "flex-wrap: " + props.wrapProp + ";" : ''); }, function (props) { return props.fillProp && fillStyle(props.fillProp); }, function (props) { return props.background && backgroundStyle(props.background); }, function (props) { return props.colorProp && "color: " + normaliseColor(props.colorProp) + ";"; }, function (props) { return props.border && borderStyle(props.border); }, function (props) { return props.overflowProp && overflowStyle(props.overflowProp); }, function (props) { return props.radiusProp && radiusStyle(props.radiusProp); }, function (props) { return props.shadow && shadowStyle(props.shadow); });
var templateObject_1$c, templateObject_2$5, templateObject_3$3, templateObject_4$3, templateObject_5$2, templateObject_6$1, templateObject_7$1, templateObject_8;

var Box = function (_a) {
    var children = _a.children, align = _a.align, alignContent = _a.alignContent, background = _a.background, basis = _a.basis, border = _a.border, color = _a.color, direction = _a.direction, fill = _a.fill, flex = _a.flex, height = _a.height, justify = _a.justify, margin = _a.margin, overflow = _a.overflow, padding = _a.padding, radius = _a.radius, shadow = _a.shadow, sticky = _a.sticky, width = _a.width, wrap = _a.wrap, rest = __rest(_a, ["children", "align", "alignContent", "background", "basis", "border", "color", "direction", "fill", "flex", "height", "justify", "margin", "overflow", "padding", "radius", "shadow", "sticky", "width", "wrap"]);
    return (React__default.createElement(BoxWrap, __assign({ align: align, alignContent: alignContent, background: background, basis: basis, border: border, colorProp: color, directionProp: direction, fillProp: fill, flex: flex, heightProp: height, justify: justify, margin: margin, overflowProp: overflow, padding: padding, radiusProp: radius, shadow: shadow, sticky: sticky, widthProp: width, wrapProp: wrap }, rest), children));
};

var StyledText = styled.span(templateObject_2$6 || (templateObject_2$6 = __makeTemplateObject(["\n  font-size: ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  text-transform: ", ";\n  text-align: ", ";\n\n  ", "\n"], ["\n  font-size: ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  text-transform: ", ";\n  text-align: ", ";\n\n  ",
    "\n"])), function (props) { return props.theme.fonts.size[props.fontSizeProp]; }, function (props) { return "color: " + normaliseColor(props.colorProp) + ";"; }, function (props) { return weightStyle(props.fontWeightProp); }, function (props) { return gapStyle('margin', props.marginProp); }, function (props) { return gapStyle('padding', props.paddingProp); }, function (props) { return props.transformProp; }, function (props) { return props.alignProp; }, function (props) {
    return props.ellipsisProp && css(templateObject_1$d || (templateObject_1$d = __makeTemplateObject(["\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    "], ["\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    "])));
});
var templateObject_1$d, templateObject_2$6;

var Text = function (_a) {
    var _b = _a.color, color = _b === void 0 ? 'coolGray-700' : _b, _c = _a.fontSize, fontSize = _c === void 0 ? 'base' : _c, _d = _a.margin, margin = _d === void 0 ? '0' : _d, _e = _a.padding, padding = _e === void 0 ? '0' : _e, _f = _a.transform, transform = _f === void 0 ? 'none' : _f, _g = _a.fontWeight, fontWeight = _g === void 0 ? 'normal' : _g, _h = _a.align, align = _h === void 0 ? 'left' : _h, rest = __rest(_a, ["color", "fontSize", "margin", "padding", "transform", "fontWeight", "align"]);
    return (React__default.createElement(StyledText, __assign({ alignProp: align, colorProp: color, fontSizeProp: fontSize, marginProp: margin, paddingProp: padding, transformProp: transform, fontWeightProp: fontWeight }, rest)));
};

var AutocompleteWrap = styled.div(templateObject_1$e || (templateObject_1$e = __makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
var SuggestionsPopup = styled.div(templateObject_2$7 || (templateObject_2$7 = __makeTemplateObject(["\n  position: absolute;\n  background: ", ";\n  max-height: 200px;\n  overflow: auto;\n  z-index: 10;\n  width: 100%;\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  position: absolute;\n  background: ", ";\n  max-height: 200px;\n  overflow: auto;\n  z-index: 10;\n  width: 100%;\n  ", ";\n  ", ";\n  ", ";\n"])), normaliseColor('white'), gapStyle('padding', '4'), shadowStyle('xl'), radiusStyle('lg'));
var SuggestionListItem = styled.li(templateObject_3$4 || (templateObject_3$4 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  cursor: pointer;\n\n  &.suggestion-active {\n    background: ", ";\n    color: ", ";\n  }\n"], ["\n  ", ";\n  ", ";\n  cursor: pointer;\n\n  &.suggestion-active {\n    background: ", ";\n    color: ", ";\n  }\n"])), gapStyle('padding', { horizontal: '2', vertical: '2' }), radiusStyle('default'), normaliseColor('purple-500'), normaliseColor('white'));
var templateObject_1$e, templateObject_2$7, templateObject_3$4;

var Autocomplete = function (_a) {
    var suggestions = _a.suggestions, placeholder = _a.placeholder, onAdd = _a.onAdd, _b = _a.emptyMessage, emptyMessage = _b === void 0 ? 'All items have been added' : _b;
    var _c = useState(false), showSuggestions = _c[0], setShowSuggestions = _c[1];
    var _d = useState(suggestions), filteredSuggestions = _d[0], setFilteredSuggestions = _d[1];
    var _e = useState(0), activeSuggestion = _e[0], setActiveSuggestion = _e[1];
    var onChange = useCallback(function (e) {
        var userInput = e.currentTarget.value;
        var filtered = suggestions.filter(function (suggestion) {
            return suggestion.toLowerCase().includes(userInput.toLowerCase());
        });
        setFilteredSuggestions(filtered);
        setActiveSuggestion(0);
    }, [suggestions]);
    var onFocus = useCallback(function () { return setShowSuggestions(true); }, []);
    var onKeyDown = useCallback(function (e) {
        // User pressed the enter key
        if (e.keyCode === 13) {
            setActiveSuggestion(0);
            onAdd(filteredSuggestions[activeSuggestion]);
        }
        // User pressed the up arrow
        else if (e.keyCode === 38) {
            if (activeSuggestion === 0) {
                return;
            }
            setActiveSuggestion(activeSuggestion - 1);
        }
        // User pressed the down arrow
        else if (e.keyCode === 40) {
            if (activeSuggestion - 1 === filteredSuggestions.length) {
                return;
            }
            setActiveSuggestion(activeSuggestion + 1);
        }
    }, [activeSuggestion, filteredSuggestions, onAdd]);
    var clickSuggestion = useCallback(function (e) {
        setActiveSuggestion(0);
        onAdd(e.target.dataset.value);
    }, [onAdd]);
    var hoverSuggestion = useCallback(function (e) { return setActiveSuggestion(~~e.target.dataset.index); }, []);
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(AutocompleteWrap, null,
            React__default.createElement(TextInput, { placeholder: placeholder, onFocus: onFocus, onKeyDown: onKeyDown, onChange: onChange }),
            showSuggestions && (React__default.createElement(OutsideClickHandler, { onOutsideClick: function () { return setShowSuggestions(false); } },
                React__default.createElement(SuggestionsPopup, null,
                    filteredSuggestions.length > 0 && (React__default.createElement("ul", null, filteredSuggestions.map(function (source, index) {
                        var className;
                        if (index === activeSuggestion) {
                            className = 'suggestion-active';
                        }
                        return (React__default.createElement(SuggestionListItem, { key: source, className: className, onClick: clickSuggestion, onMouseEnter: hoverSuggestion, "data-value": source, "data-index": index }, source));
                    }))),
                    filteredSuggestions.length === 0 && (React__default.createElement(Box, { width: "full" },
                        React__default.createElement(Text, { fontWeight: "bold" }, emptyMessage)))))))));
};

var buttonColors = {
    primary: {
        normal: {
            background: 'pink-500',
            text: 'white',
        },
        hover: {
            background: 'pink-700',
            text: 'white',
        },
    },
    secondary: {
        normal: {
            background: 'purple-500',
            text: 'white',
        },
        hover: {
            background: 'purple-700',
            text: 'white',
        },
    },
    success: {
        normal: {
            background: 'green-500',
            text: 'white',
        },
        hover: {
            background: 'green-700',
            text: 'white',
        },
    },
    info: {
        normal: {
            background: 'blue-500',
            text: 'white',
        },
        hover: {
            background: 'blue-700',
            text: 'white',
        },
    },
    warning: {
        normal: {
            background: 'orange-500',
            text: 'white',
        },
        hover: {
            background: 'orange-700',
            text: 'white',
        },
    },
    danger: {
        normal: {
            background: 'red-700',
            text: 'white',
        },
        hover: {
            background: 'red-900',
            text: 'white',
        },
    },
    plain: {
        normal: {
            background: 'coolGray-400',
            text: 'coolGray-600',
        },
        hover: {
            background: 'coolGray-600',
            text: 'white',
        },
    },
    white: {
        normal: {
            background: 'white',
            text: 'pink-500',
        },
        hover: {
            background: "rgba(255,255,255,.75)",
            text: 'pink-500',
        },
    },
    link: {
        normal: {
            background: 'transparent',
            text: 'pink-500',
        },
        hover: {
            background: 'transparent',
            text: 'pink-700',
        },
    },
};
var StyledButton = styled.button(templateObject_5$3 || (templateObject_5$3 = __makeTemplateObject(["\n  display: inline-block;\n  box-sizing: border-box;\n  cursor: pointer;\n  border: 0;\n  outline: none;\n  font: inherit;\n  background: transparent;\n  overflow: visible;\n  text-decoration: none;\n  text-transform: none;\n  line-height: 1.25rem;\n  ", "\n  ", "\n  transition: color 300ms ease, background-color 300ms ease;\n\n  ", ";\n\n  &:disabled {\n    opacity: 0.5;\n  }\n\n  ", ";\n\n  ", ";\n\n  ", ";\n"], ["\n  display: inline-block;\n  box-sizing: border-box;\n  cursor: pointer;\n  border: 0;\n  outline: none;\n  font: inherit;\n  background: transparent;\n  overflow: visible;\n  text-decoration: none;\n  text-transform: none;\n  line-height: 1.25rem;\n  ", "\n  ",
    "\n  transition: color 300ms ease, background-color 300ms ease;\n\n  ",
    ";\n\n  &:disabled {\n    opacity: 0.5;\n  }\n\n  ",
    ";\n\n  ",
    ";\n\n  ",
    ";\n"])), function (props) { return weightStyle(props.weightProp); }, function (props) {
    return gapStyle('margin', props.margin || '0');
}, function (_a) {
    var buttonTheme = _a.buttonTheme, buttonStyle = _a.buttonStyle;
    return css(templateObject_1$f || (templateObject_1$f = __makeTemplateObject(["\n      ", "\n\n      ", "\n\n      &.active,\n      &:hover {\n        ", "\n\n        ", "\n      }\n    "], ["\n      ",
        "\n\n      ",
        "\n\n      &.active,\n      &:hover {\n        ",
        "\n\n        ",
        "\n      }\n    "])), buttonStyle === 'filled' &&
        "\n          background-color: " + normaliseColor(buttonColors[buttonTheme].normal.background) + ";\n          color: " + normaliseColor(buttonColors[buttonTheme].normal.text) + ";\n      ", buttonStyle === 'outline' &&
        "\n        color: " + normaliseColor(buttonColors[buttonTheme].normal.background) + ";\n        border-width: 1px;\n        border-style: solid;\n        border-color: " + normaliseColor(buttonColors[buttonTheme].normal.background) + ";\n      ", buttonStyle === 'filled' &&
        "\n        background-color: " + normaliseColor(buttonColors[buttonTheme].hover.background) + ";\n        color: " + normaliseColor(buttonColors[buttonTheme].hover.text) + ";\n      ", buttonStyle === 'outline' &&
        "\n          color: " + normaliseColor(buttonColors[buttonTheme].hover.background) + ";\n          border-color: " + normaliseColor(buttonColors[buttonTheme].hover.background) + ";\n      ");
}, function (props) {
    return props.size === 'small' && css(templateObject_2$8 || (templateObject_2$8 = __makeTemplateObject(["\n      font-size: ", ";\n      ", "\n      ", "\n    "], ["\n      font-size: ", ";\n      ",
        "\n      ", "\n    "])), function (_a) {
        var theme = _a.theme;
        return theme.fonts.size[props.fontSize || 'sm'];
    }, gapStyle('padding', props.padding || { horizontal: '2', vertical: '2' }), radiusStyle(props.radiusProp || 'default'));
}, function (props) {
    return props.size === 'medium' && css(templateObject_3$5 || (templateObject_3$5 = __makeTemplateObject(["\n      font-size: ", ";\n      ", "\n      ", "\n    "], ["\n      font-size: ", ";\n      ",
        "\n      ", "\n    "])), function (_a) {
        var theme = _a.theme;
        return theme.fonts.size[props.fontSize || 'base'];
    }, gapStyle('padding', props.padding || { horizontal: '4', vertical: '2' }), radiusStyle(props.radiusProp || 'md'));
}, function (props) {
    return props.size === 'large' && css(templateObject_4$4 || (templateObject_4$4 = __makeTemplateObject(["\n      font-size: ", ";\n      ", "\n      ", "\n    "], ["\n      font-size: ", ";\n      ",
        "\n      ", "\n    "])), props.theme.fonts.size[props.fontSize || 'lg'], gapStyle('padding', props.padding || { horizontal: '6', vertical: '3' }), radiusStyle(props.radiusProp || 'lg'));
});
var templateObject_1$f, templateObject_2$8, templateObject_3$5, templateObject_4$4, templateObject_5$3;

var Button = function (_a) {
    var radius = _a.radius, color = _a.color, _b = _a.weight, weight = _b === void 0 ? 'medium' : _b, _c = _a.theme, theme = _c === void 0 ? 'primary' : _c, _d = _a.style, style = _d === void 0 ? 'filled' : _d, _e = _a.size, size = _e === void 0 ? 'medium' : _e, rest = __rest(_a, ["radius", "color", "weight", "theme", "style", "size"]);
    return (React__default.createElement(StyledButton, __assign({}, rest, { buttonTheme: theme, buttonStyle: style, radiusProp: radius, colorProp: color, weightProp: weight, size: size })));
};

var StyledButtonGroup = styled.div(templateObject_1$g || (templateObject_1$g = __makeTemplateObject(["\n  ", "\n\n  > button:not(:first-child) {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n  > button:not(:last-child) {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n  }\n"], ["\n  ", "\n\n  > button:not(:first-child) {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n  > button:not(:last-child) {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n  }\n"])), function (props) { return props.padding && gapStyle('padding', props.padding); });
var templateObject_1$g;

var ButtonGroup = function (_a) {
    var children = _a.children, padding = _a.padding;
    return React__default.createElement(StyledButtonGroup, { padding: padding }, children);
};

var Card = function (_a) {
    var children = _a.children, _b = _a.background, background = _b === void 0 ? 'white' : _b, _c = _a.margin, margin = _c === void 0 ? '0' : _c, _d = _a.padding, padding = _d === void 0 ? '8' : _d, _e = _a.shadow, shadow = _e === void 0 ? 'default' : _e, _f = _a.radius, radius = _f === void 0 ? 'lg' : _f, _g = _a.wrap, wrap = _g === void 0 ? 'nowrap' : _g, _h = _a.align, align = _h === void 0 ? 'start' : _h, _j = _a.direction, direction = _j === void 0 ? 'column' : _j, rest = __rest(_a, ["children", "background", "margin", "padding", "shadow", "radius", "wrap", "align", "direction"]);
    return (React__default.createElement(Box, __assign({ margin: margin, background: background, shadow: shadow, radius: radius, wrap: wrap, align: align, direction: direction, padding: padding }, rest), children));
};

var StyledCheckboxWrapper = styled.div(templateObject_1$h || (templateObject_1$h = __makeTemplateObject(["\n  position: relative;\n  display: flex;\n  ", ";\n  max-width: ", "};\n  ", "\n  ", "\n\n  label {\n    display: flex;\n    align-items: center;\n  }\n"], ["\n  position: relative;\n  display: flex;\n  ", ";\n  max-width: ",
    "};\n  ", "\n  ", "\n\n  label {\n    display: flex;\n    align-items: center;\n  }\n"])), function (props) { return props.flex && "flex: " + props.flex; }, function (props) {
    return (props.widthProp && props.theme.width[props.widthProp]) ||
        props.widthProp;
}, function (props) { return props.padding && gapStyle('padding', props.padding); }, function (props) { return props.margin && gapStyle('margin', props.margin); });
var StyledCheckboxWrap = styled.div(templateObject_2$9 || (templateObject_2$9 = __makeTemplateObject(["\n  display: inline-block;\n  vertical-align: middle;\n"], ["\n  display: inline-block;\n  vertical-align: middle;\n"])));
var Icon = styled.svg(templateObject_3$6 || (templateObject_3$6 = __makeTemplateObject(["\n  fill: none;\n  stroke: ", ";\n  stroke-width: 3px;\n"], ["\n  fill: none;\n  stroke: ", ";\n  stroke-width: 3px;\n"])), normaliseColor('pink-500'));
var HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })(templateObject_4$5 || (templateObject_4$5 = __makeTemplateObject(["\n  border: 0;\n  clip: rect(0 0 0 0);\n  clip-path: inset(50%);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  white-space: nowrap;\n  width: 1px;\n"], ["\n  border: 0;\n  clip: rect(0 0 0 0);\n  clip-path: inset(50%);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  white-space: nowrap;\n  width: 1px;\n"])));
var StyledCheckbox = styled.div(templateObject_5$4 || (templateObject_5$4 = __makeTemplateObject(["\n  width: 16px;\n  height: 16px;\n  background: ", ";\n  ", ";\n  transition: all 300ms ease;\n  border: 1px solid;\n  border-color: transparent;\n  ", ";\n\n  ", ":focus + & {\n    box-shadow: 0 0 0 3px ", ";\n    border-color: ", ";\n  }\n\n  ", " {\n    visibility: ", ";\n  }\n"], ["\n  width: 16px;\n  height: 16px;\n  background: ", ";\n  ", ";\n  transition: all 300ms ease;\n  border: 1px solid;\n  border-color: transparent;\n  ", ";\n\n  ", ":focus + & {\n    box-shadow: 0 0 0 3px ", ";\n    border-color: ", ";\n  }\n\n  ", " {\n    visibility: ", ";\n  }\n"])), normaliseColor('coolGray-200'), radiusStyle('default'), gapStyle('margin', { right: '1' }), HiddenCheckbox, normaliseColor('pink-100'), normaliseColor('pink-500'), Icon, function (props) { return (props.checked ? 'visible' : 'hidden'); });
var templateObject_1$h, templateObject_2$9, templateObject_3$6, templateObject_4$5, templateObject_5$4;

var Checkbox = function (_a) {
    var className = _a.className, checked = _a.checked, padding = _a.padding, margin = _a.margin, width = _a.width, label = _a.label, props = __rest(_a, ["className", "checked", "padding", "margin", "width", "label"]);
    return (React__default.createElement(StyledCheckboxWrapper, { padding: padding, margin: margin, widthProp: width },
        React__default.createElement(Label, { color: "coolGray-700", weight: "medium" },
            React__default.createElement(StyledCheckboxWrap, { className: className },
                React__default.createElement(HiddenCheckbox, __assign({ checked: checked }, props)),
                React__default.createElement(StyledCheckbox, { checked: checked },
                    React__default.createElement(Icon, { viewBox: "0 0 24 24" },
                        React__default.createElement("polyline", { points: "20 6 9 17 4 12" })))),
            label)));
};

var Container = function (_a) {
    var children = _a.children, background = _a.background, _b = _a.padding, padding = _b === void 0 ? '8' : _b, _c = _a.width, width = _c === void 0 ? { base: 'full', max: '1800px' } : _c, height = _a.height, rest = __rest(_a, ["children", "background", "padding", "width", "height"]);
    return (React__default.createElement(Box, __assign({ margin: { horizontal: 'auto', vertical: '0' }, padding: padding, width: width, height: height }, rest), children));
};

var StyledDateWrapper = styled.div(templateObject_1$i || (templateObject_1$i = __makeTemplateObject(["\n  display: flex;\n  position: relative;\n  width: 100%;\n  ", ";\n  max-width: ", "};\n  ", ";\n  ", ";\n\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  /* Overwrite DatePicker Style */\n  .react-datepicker-wrapper {\n    flex: 1;\n  }\n  .react-datepicker {\n    border: 0;\n    font-family: ", ";\n    ", "\n\n    .react-datepicker__triangle {\n      border-bottom-color: ", ";\n      &:before {\n        border: 0;\n      }\n    }\n\n    .react-datepicker__header {\n      background: ", ";\n      border-bottom: 0;\n    }\n\n    .react-datepicker__header--time {\n      padding-bottom: 8px;\n      padding-left: 5px;\n      padding-right: 5px;\n      height: 52px;\n      vertical-align: middle;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    }\n\n    .react-datepicker__day-name,\n    .react-datepicker__day,\n    .react-datepicker__time-name {\n      color: ", ";\n      margin: 0.166rem 0.5rem;\n    }\n\n    .react-datepicker__day:hover,\n    .react-datepicker__month-text:hover,\n    .react-datepicker__quarter-text:hover {\n      border-radius: 0.3rem;\n      background: ", ";\n    }\n\n    .react-datepicker__day--selected,\n    .react-datepicker__day--in-selecting-range,\n    .react-datepicker__day--in-range,\n    .react-datepicker__month-text--selected,\n    .react-datepicker__month-text--in-selecting-range,\n    .react-datepicker__month-text--in-range,\n    .react-datepicker__quarter-text--selected,\n    .react-datepicker__quarter-text--in-selecting-range,\n    .react-datepicker__quarter-text--in-range {\n      border-radius: 0.3rem;\n      background-color: ", ";\n      color: #fff;\n    }\n    .react-datepicker__day--disabled,\n    .react-datepicker__month-text--disabled,\n    .react-datepicker__quarter-text--disabled {\n      cursor: default;\n      color: ", ";\n    }\n\n    .react-datepicker__time-container\n      .react-datepicker__time\n      .react-datepicker__time-box\n      ul.react-datepicker__time-list\n      li.react-datepicker__time-list-item {\n      height: 30px;\n      padding: 5px 10px;\n      white-space: nowrap;\n      justify-content: center;\n      align-items: center;\n      display: flex;\n    }\n\n    .react-datepicker__time-container\n      .react-datepicker__time\n      .react-datepicker__time-box\n      ul.react-datepicker__time-list\n      li.react-datepicker__time-list-item:hover {\n      cursor: pointer;\n      background: ", ";\n    }\n\n    .react-datepicker__time-container\n      .react-datepicker__time\n      .react-datepicker__time-box\n      ul.react-datepicker__time-list\n      li.react-datepicker__time-list-item--selected {\n      background-color: ", ";\n    }\n  }\n"], ["\n  display: flex;\n  position: relative;\n  width: 100%;\n  ", ";\n  max-width: ",
    "};\n  ",
    ";\n  ", ";\n\n  ",
    ";\n  ",
    ";\n  ",
    ";\n  ",
    ";\n\n  /* Overwrite DatePicker Style */\n  .react-datepicker-wrapper {\n    flex: 1;\n  }\n  .react-datepicker {\n    border: 0;\n    font-family: ",
    ";\n    ", "\n\n    .react-datepicker__triangle {\n      border-bottom-color: ", ";\n      &:before {\n        border: 0;\n      }\n    }\n\n    .react-datepicker__header {\n      background: ", ";\n      border-bottom: 0;\n    }\n\n    .react-datepicker__header--time {\n      padding-bottom: 8px;\n      padding-left: 5px;\n      padding-right: 5px;\n      height: 52px;\n      vertical-align: middle;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    }\n\n    .react-datepicker__day-name,\n    .react-datepicker__day,\n    .react-datepicker__time-name {\n      color: ", ";\n      margin: 0.166rem 0.5rem;\n    }\n\n    .react-datepicker__day:hover,\n    .react-datepicker__month-text:hover,\n    .react-datepicker__quarter-text:hover {\n      border-radius: 0.3rem;\n      background: ", ";\n    }\n\n    .react-datepicker__day--selected,\n    .react-datepicker__day--in-selecting-range,\n    .react-datepicker__day--in-range,\n    .react-datepicker__month-text--selected,\n    .react-datepicker__month-text--in-selecting-range,\n    .react-datepicker__month-text--in-range,\n    .react-datepicker__quarter-text--selected,\n    .react-datepicker__quarter-text--in-selecting-range,\n    .react-datepicker__quarter-text--in-range {\n      border-radius: 0.3rem;\n      background-color: ", ";\n      color: #fff;\n    }\n    .react-datepicker__day--disabled,\n    .react-datepicker__month-text--disabled,\n    .react-datepicker__quarter-text--disabled {\n      cursor: default;\n      color: ", ";\n    }\n\n    .react-datepicker__time-container\n      .react-datepicker__time\n      .react-datepicker__time-box\n      ul.react-datepicker__time-list\n      li.react-datepicker__time-list-item {\n      height: 30px;\n      padding: 5px 10px;\n      white-space: nowrap;\n      justify-content: center;\n      align-items: center;\n      display: flex;\n    }\n\n    .react-datepicker__time-container\n      .react-datepicker__time\n      .react-datepicker__time-box\n      ul.react-datepicker__time-list\n      li.react-datepicker__time-list-item:hover {\n      cursor: pointer;\n      background: ", ";\n    }\n\n    .react-datepicker__time-container\n      .react-datepicker__time\n      .react-datepicker__time-box\n      ul.react-datepicker__time-list\n      li.react-datepicker__time-list-item--selected {\n      background-color: ", ";\n    }\n  }\n"])), function (props) { return props.flex && "flex: " + props.flex; }, function (props) {
    return (props.widthProp && props.theme.width[props.widthProp]) ||
        props.widthProp;
}, function (props) {
    return props.minWidthProp &&
        "max-width: " + (props.theme.width[props.minWidthProp] ||
            props.minWidthProp);
}, function (props) { return props.padding && gapStyle('padding', props.padding); }, function (_a) {
    var labelPosition = _a.labelPosition;
    return labelPosition === 'top' &&
        "\n      flex-direction: column;\n    ";
}, function (_a) {
    var labelPosition = _a.labelPosition;
    return labelPosition === 'bottom' &&
        "\n      flex-direction: column-reverse;\n    ";
}, function (_a) {
    var labelPosition = _a.labelPosition;
    return labelPosition === 'left' &&
        "\n      align-items: center;\n      flex-direction: row;\n    ";
}, function (_a) {
    var labelPosition = _a.labelPosition;
    return labelPosition === 'right' &&
        "\n      align-items: center;\n      flex-direction: row-reverse;\n    ";
}, function (_a) {
    var theme = _a.theme;
    return "" + theme.fonts.family.sans;
}, shadowStyle('lg'), normaliseColor('coolGray-200'), normaliseColor('coolGray-200'), normaliseColor('coolGray-700'), normaliseColor('coolGray-300'), normaliseColor('pink-500'), normaliseColor('coolGray-300'), normaliseColor('coolGray-300'), normaliseColor('pink-500'));
var DateLabel = styled(Label)(templateObject_6$2 || (templateObject_6$2 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  ",
    ";\n  ",
    ";\n  ",
    ";\n  ",
    ";\n"])), function (_a) {
    var labelPosition = _a.labelPosition;
    return labelPosition === 'top' && css(templateObject_2$a || (templateObject_2$a = __makeTemplateObject(["\n      ", "\n    "], ["\n      ",
        "\n    "])), gapStyle('margin', {
        bottom: '2',
    }));
}, function (_a) {
    var labelPosition = _a.labelPosition;
    return labelPosition === 'bottom' && css(templateObject_3$7 || (templateObject_3$7 = __makeTemplateObject(["\n      ", "\n    "], ["\n      ",
        "\n    "])), gapStyle('margin', {
        top: '2',
    }));
}, function (_a) {
    var labelPosition = _a.labelPosition;
    return labelPosition === 'left' && css(templateObject_4$6 || (templateObject_4$6 = __makeTemplateObject(["\n      ", "\n    "], ["\n      ",
        "\n    "])), gapStyle('margin', {
        right: '2',
    }));
}, function (_a) {
    var labelPosition = _a.labelPosition;
    return labelPosition === 'right' && css(templateObject_5$5 || (templateObject_5$5 = __makeTemplateObject(["\n      ", "\n    "], ["\n      ",
        "\n    "])), gapStyle('margin', {
        left: '2',
    }));
});
var templateObject_1$i, templateObject_2$a, templateObject_3$7, templateObject_4$6, templateObject_5$5, templateObject_6$2;

var DatePicker = function (_a) {
    var label = _a.label, padding = _a.padding, _b = _a.width, width = _b === void 0 ? 'full' : _b, _c = _a.labelPosition, labelPosition = _c === void 0 ? 'left' : _c, _d = _a.dateFormat, dateFormat = _d === void 0 ? 'EEE dd MMMM yyyy' : _d, rest = __rest(_a, ["label", "padding", "width", "labelPosition", "dateFormat"]);
    return (React__default.createElement(StyledDateWrapper, { labelPosition: labelPosition, padding: padding, widthProp: width },
        label && (React__default.createElement(DateLabel, { color: "coolGray-700", weight: "medium", labelPosition: labelPosition }, label)),
        React__default.createElement(Pickr, __assign({}, rest, { dateFormat: dateFormat, customInput: React__default.createElement(TextInput, null) }))));
};

var DragHandle = styled(Box)(templateObject_1$j || (templateObject_1$j = __makeTemplateObject(["\n  position: relative;\n  top: 1px;\n  display: block;\n  width: 18px;\n  height: 11px;\n  opacity: 0.25;\n  margin-right: 20px;\n  cursor: row-resize;\n  background: -webkit-linear-gradient(\n    top,\n    #000,\n    #000 20%,\n    #fff 0,\n    #fff 40%,\n    #000 0,\n    #000 60%,\n    #fff 0,\n    #fff 80%,\n    #000 0,\n    #000\n  );\n  background: linear-gradient(\n    180deg,\n    #000,\n    #000 20%,\n    #fff 0,\n    #fff 40%,\n    #000 0,\n    #000 60%,\n    #fff 0,\n    #fff 80%,\n    #000 0,\n    #000\n  );\n"], ["\n  position: relative;\n  top: 1px;\n  display: block;\n  width: 18px;\n  height: 11px;\n  opacity: 0.25;\n  margin-right: 20px;\n  cursor: row-resize;\n  background: -webkit-linear-gradient(\n    top,\n    #000,\n    #000 20%,\n    #fff 0,\n    #fff 40%,\n    #000 0,\n    #000 60%,\n    #fff 0,\n    #fff 80%,\n    #000 0,\n    #000\n  );\n  background: linear-gradient(\n    180deg,\n    #000,\n    #000 20%,\n    #fff 0,\n    #fff 40%,\n    #000 0,\n    #000 60%,\n    #fff 0,\n    #fff 80%,\n    #000 0,\n    #000\n  );\n"])));
var templateObject_1$j;

var StyledEm = styled.em(templateObject_1$k || (templateObject_1$k = __makeTemplateObject(["\n  font-size: ", ";\n  ", "\n  ", "\n  text-transform: ", ";\n"], ["\n  font-size: ", ";\n  ", "\n  ", "\n  text-transform: ", ";\n"])), function (props) { return props.theme.fonts.size[props.sizeProp]; }, function (props) { return "color: " + normaliseColor(props.colorProp) + ";"; }, function (props) { return weightStyle(props.weight); }, function (props) { return props.transform; });
var templateObject_1$k;

var Em = function (_a) {
    var _b = _a.color, color = _b === void 0 ? 'coolGray-500' : _b, _c = _a.weight, weight = _c === void 0 ? 'bold' : _c, _d = _a.transform, transform = _d === void 0 ? 'none' : _d, _e = _a.size, size = _e === void 0 ? 'base' : _e, rest = __rest(_a, ["color", "weight", "transform", "size"]);
    return (React__default.createElement(StyledEm, __assign({}, rest, { colorProp: color, weight: weight, transform: transform, sizeProp: size })));
};

var StyledError = styled.div(templateObject_1$l || (templateObject_1$l = __makeTemplateObject(["\n  color: ", ";\n  ", "\n  &:before {\n    display: inline;\n    content: '\u26A0 ';\n  }\n"], ["\n  color: ", ";\n  ",
    "\n  &:before {\n    display: inline;\n    content: '\u26A0 ';\n  }\n"])), normaliseColor('red-600'), gapStyle('padding', {
    top: '3',
    bottom: '3',
}));
var templateObject_1$l;

var ErrorMessage = function (_a) {
    var error = _a.error;
    if (error) {
        switch (error.type) {
            case 'required':
                return React__default.createElement(StyledError, null, "This is required");
            case 'pattern':
                return React__default.createElement(StyledError, null, error.message);
            case 'minLength':
                return (React__default.createElement(StyledError, null, "Must be at least 8 characters in length"));
            case 'hasNumbers':
                return React__default.createElement(StyledError, null, "Must include a number (i.e. 0-9)");
            case 'hasSmallCase':
                return React__default.createElement(StyledError, null, "Must include lower case letters (a-z)");
            case 'hasCapitalCase':
                return React__default.createElement(StyledError, null, "Must include upper case letters (A-Z)");
            case 'hasSpecialCharacters':
                return (React__default.createElement(StyledError, null, "Must include special characters (e.g. !@#$%^&*)"));
            case 'hasMultipleLetters':
                return (React__default.createElement(StyledError, null, "No more than 2 identical characters in a row (e.g., \"aaa\" not allowed)"));
            case 'length':
                return (React__default.createElement(StyledError, null, "Must be at least 8 characters in length"));
            default:
                return React__default.createElement(StyledError, null, error.message);
        }
    }
    return null;
};

var TEXT_ALIGN_MAP = {
    center: 'center',
    end: 'right',
    start: 'left',
};
var textAlignStyle = function (textAlign) { return css(templateObject_1$m || (templateObject_1$m = __makeTemplateObject(["\n  text-align: ", ";\n"], ["\n  text-align: ", ";\n"])), TEXT_ALIGN_MAP[textAlign]); };
var truncateStyle = "\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n";
var HeadingWrap = styled.h1(templateObject_2$b || (templateObject_2$b = __makeTemplateObject(["\n  ", ";\n  ", "\n  ", "\n  ", "\n  ", "\n  ", ";\n"], ["\n  ", ";\n  ", "\n  ", "\n  ", "\n  ", "\n  ", ";\n"])), function (props) { return weightStyle(props.weightProp); }, function (props) { return props.marginProp && gapStyle('margin', props.marginProp); }, function (props) { return "font-size: " + props.theme.headings.level[props.level].size + ";"; }, function (props) { return props.textAlign && textAlignStyle(props.textAlign); }, function (props) { return props.truncate && truncateStyle; }, function (props) { return props.colorProp && "color: " + normaliseColor(props.colorProp) + ";"; });
var templateObject_1$m, templateObject_2$b;

var Heading = function (_a) {
    var _b = _a.level, level = _b === void 0 ? '1' : _b, _c = _a.color, color = _c === void 0 ? 'coolGray-700' : _c, _d = _a.margin, margin = _d === void 0 ? { bottom: 3 } : _d, _e = _a.weight, weight = _e === void 0 ? 'bold' : _e, rest = __rest(_a, ["level", "color", "margin", "weight"]);
    return (React__default.createElement(HeadingWrap, __assign({ colorProp: color, level: level, marginProp: margin, weightProp: weight }, rest)));
};

var duration = 1.4;
var offset$1 = 187;
var LoadingSpinnerWrap = styled.div(templateObject_1$n || (templateObject_1$n = __makeTemplateObject(["\n  margin: 0 auto;\n\n  .spinner {\n    animation: ", " ", "s linear infinite;\n  }\n\n  .path {\n    stroke-dasharray: ", ";\n    stroke-dashoffset: 0;\n    transform-origin: center;\n    animation: ", " ", "s ease-in-out infinite,\n      ", " ", "s ease-in-out alternate\n        infinite;\n  }\n"], ["\n  margin: 0 auto;\n\n  .spinner {\n    animation: ", " ", "s linear infinite;\n  }\n\n  .path {\n    stroke-dasharray: ", ";\n    stroke-dashoffset: 0;\n    transform-origin: center;\n    animation: ", " ", "s ease-in-out infinite,\n      ", " ", "s ease-in-out alternate\n        infinite;\n  }\n"])), rotator, duration, offset$1, dash, duration, function (props) { return colors$1(props.colors); }, duration);
var templateObject_1$n;

var SIZE_MAP = {
    small: '20px',
    medium: '40px',
    large: '65px',
};
var LoadingSpinner = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 'large' : _b, _c = _a.colors, colors = _c === void 0 ? { first: 'purple-500', second: 'pink-500' } : _c;
    return (createElement(LoadingSpinnerWrap, { colors: colors },
        createElement("svg", { className: "spinner", width: SIZE_MAP[size], height: SIZE_MAP[size], viewBox: "0 0 66 66", xmlns: "http://www.w3.org/2000/svg" },
            createElement("circle", { className: "path", fill: "none", strokeWidth: "6", strokeLinecap: "round", cx: "33", cy: "33", r: "30" }))));
};

var LogoWrap = styled.div(templateObject_1$o || (templateObject_1$o = __makeTemplateObject(["\n  ", ";\n\n  svg {\n    width: 100%;\n    height: 100%;\n  }\n"], ["\n  ",
    ";\n\n  svg {\n    width: 100%;\n    height: 100%;\n  }\n"])), function (_a) {
    var icon = _a.icon, size = _a.size, width = _a.width, height = _a.height;
    if (width || height) {
        return "\n        width: " + width + ";\n        height: " + height + ";\n      ";
    }
    if (icon) {
        if (size === 'small') {
            return "\n          width: 15px;\n        ";
        }
        if (size === 'medium') {
            return "\n          width: 35px;\n        ";
        }
        if (size === 'large') {
            return "\n          width: 70px;\n        ";
        }
    }
    else {
        if (size === 'small') {
            return "\n        width: 75px;\n      ";
        }
        if (size === 'medium') {
            return "\n        width: 150px;\n      ";
        }
        if (size === 'large') {
            return "\n        width: 300px;\n      ";
        }
    }
    if (size === 'fill') {
        return "\n        width: 100%;\n      ";
    }
    return "\n      width: " + size + ";\n    ";
});
var templateObject_1$o;

var Logo = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 'medium' : _b, width = _a.width, height = _a.height, _c = _a.dark, dark = _c === void 0 ? false : _c, _d = _a.icon, icon = _d === void 0 ? false : _d;
    var logo = (React__default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlSpace: "preserve", width: "188.637mm", height: "34.1048mm", version: "1.1", style: {
            shapeRendering: 'geometricPrecision',
            textRendering: 'geometricPrecision',
            // imageRendering: 'optimizeQuality',
            fillRule: 'evenodd',
            clipRule: 'evenodd',
        }, viewBox: "0 0 18864 3410", xmlnsXlink: "http://www.w3.org/1999/xlink" },
        React__default.createElement("g", { id: "Layer_x0020_1" },
            React__default.createElement("metadata", { id: "CorelCorpID_0Corel-Layer" }),
            React__default.createElement("g", { id: "_530466400" },
                React__default.createElement("path", { fill: "#D92982", d: "M675 306c58,33 91,90 91,158l0 463c0,68 -33,125 -91,158 -58,34 -124,34 -182,0l-402 -232c-58,-33 -91,-90 -91,-157l0 -464c0,-1 0,-1 0,-2l0 -114c0,-43 21,-79 58,-100 36,-21 78,-21 115,0l100 58 402 232z" }),
                React__default.createElement("path", { fill: "#330066", d: "M273 2647l324 187c59,34 92,90 92,158 0,67 -33,124 -92,158l-324 187c0,0 -1,0 -1,1l-99 57c-37,21 -79,21 -115,0 -37,-22 -58,-58 -58,-100l0 -113c0,-1 0,-2 0,-2 0,-1 0,-1 0,-1l0 -374c0,-68 33,-125 91,-158 58,-34 124,-34 182,0zm1115 -1930l1438 830 100 58c37,21 58,58 58,100 0,43 -21,79 -58,100l-94 55 -4 2c-1,0 -2,1 -2,1l-402 232c-58,34 -124,34 -182,0l-1037 -598c-58,-34 -91,-91 -91,-158l0 -464 0 -116c0,-42 21,-79 58,-100 37,-21 79,-21 115,0l101 58zm-1115 643l1439 831c58,33 91,90 91,157 0,68 -33,125 -91,158l-402 232c-58,34 -124,34 -182,0l-1037 -598c-58,-34 -91,-91 -91,-158l0 -464 0 -116c0,-42 21,-78 58,-100 36,-21 78,-21 115,0l100 58z" }),
                React__default.createElement("path", { fill: "#D92982", d: "M273 3337l-1 1c0,0 0,0 0,-1 0,0 1,0 1,0z" }),
                React__default.createElement("path", { fill: "#330066", d: "M4907 2450l-72 -951 -329 761 -277 0 -329 -761 -72 951 -314 0 124 -1516 353 0 377 951 377 -951 353 0 123 1516 -314 0zm1495 -39c-62,15 -129,29 -201,42 -71,13 -152,19 -241,19 -77,0 -146,-9 -208,-26 -62,-17 -115,-47 -159,-90 -44,-42 -78,-100 -102,-173 -24,-73 -36,-164 -36,-274 0,-81 4,-156 12,-224 8,-69 29,-128 63,-179 34,-51 85,-90 155,-118 69,-28 166,-42 290,-42 123,0 217,15 283,46 65,31 112,74 140,129 29,55 44,120 48,194 4,74 5,155 5,242l0 30 -704 0c3,53 9,97 18,132 8,35 23,62 43,82 20,21 47,35 81,43 34,7 79,11 134,11l32 0c61,-1 112,-5 155,-11 43,-7 83,-12 120,-15l67 182 5 0zm-223 -602c-2,-49 -5,-90 -10,-123 -5,-33 -15,-60 -28,-79 -14,-20 -34,-34 -60,-41 -26,-8 -61,-12 -104,-12 -51,0 -91,4 -120,13 -30,8 -52,22 -67,42 -15,19 -26,46 -31,79 -5,33 -8,74 -9,121l429 0zm1187 -444l0 208 -310 0 0 557c0,40 9,72 28,95 19,23 61,34 126,33 18,0 39,-1 60,-4 22,-2 45,-4 70,-7l30 203c-39,6 -78,11 -116,15 -38,3 -75,5 -112,5 -57,0 -109,-6 -156,-17 -46,-12 -85,-31 -118,-57 -32,-26 -57,-60 -75,-104 -18,-43 -27,-96 -27,-160l0 -557 -159 0 0 -208 174 0 30 -264 247 0 0 264 308 -2zm266 67c75,-24 153,-44 233,-60 80,-16 158,-24 233,-24 62,0 120,6 174,19 54,13 102,36 142,67 40,32 72,74 95,125 23,51 35,115 35,192l0 621c-36,19 -77,35 -122,48 -46,13 -94,24 -143,31 -50,8 -101,14 -153,18 -52,3 -103,5 -152,5 -143,0 -246,-31 -309,-94 -64,-63 -96,-159 -96,-289 0,-110 38,-187 114,-231 76,-44 185,-65 328,-64l243 0 0 -45c0,-75 -20,-127 -60,-156 -40,-29 -93,-44 -159,-44 -46,0 -98,6 -155,18 -57,11 -118,26 -183,43l-63 -182 -2 2zm399 527c-125,0 -187,44 -187,132 0,72 13,122 39,150 26,29 68,43 126,43 40,0 81,-3 122,-8 41,-5 81,-15 118,-31l0 -286 -216 0 -2 0zm1481 -1025c234,0 351,123 351,368 0,185 -66,301 -197,347 97,19 166,59 209,121 43,62 64,153 64,273 0,146 -33,250 -97,313 -65,63 -174,94 -325,94l-629 0 0 -1516 624 0zm-483 672l436 0c86,0 151,-23 195,-69 43,-45 65,-116 65,-211 0,-95 -22,-165 -65,-210 -44,-45 -109,-67 -195,-67l-436 0 0 557zm0 732l446 0c116,0 198,-24 246,-71 49,-47 73,-126 73,-239 0,-113 -24,-192 -73,-238 -48,-46 -130,-70 -246,-70l-446 0 0 618zm1633 -999c32,0 63,4 93,11 29,7 56,15 80,24 24,8 44,17 60,26 17,8 27,15 32,19l-57 85c-2,0 -10,-3 -21,-10 -12,-6 -27,-13 -46,-21 -18,-7 -39,-13 -63,-19 -23,-6 -46,-9 -71,-9 -48,0 -98,9 -152,25 -53,17 -101,35 -143,53l0 925 -134 0 0 -985c29,-15 61,-29 95,-44 35,-14 71,-27 108,-39 36,-11 74,-21 111,-28 38,-7 74,-11 108,-11l0 -2zm947 5c82,0 155,9 218,29 63,19 115,50 157,92 42,42 73,96 94,163 21,68 32,149 32,246 0,110 -11,203 -31,279 -20,75 -51,137 -92,184 -41,47 -93,81 -156,102 -63,20 -137,31 -222,31 -91,0 -168,-10 -233,-29 -64,-20 -117,-52 -158,-98 -41,-45 -71,-106 -90,-182 -19,-76 -28,-171 -28,-285 0,-98 11,-180 34,-248 22,-67 55,-121 97,-163 43,-42 96,-72 159,-91 64,-19 137,-28 219,-28l0 -2zm2 97c-63,0 -118,7 -165,21 -47,13 -86,37 -117,71 -31,34 -55,79 -70,134 -15,56 -22,126 -22,209 0,100 6,182 19,246 13,65 34,115 64,152 30,37 68,62 116,76 47,13 106,20 175,20 62,0 117,-7 163,-22 46,-16 84,-42 113,-81 30,-38 52,-89 67,-152 14,-64 21,-143 21,-239 0,-82 -7,-151 -21,-206 -15,-56 -37,-101 -68,-135 -30,-34 -68,-58 -114,-71 -47,-14 -101,-21 -163,-21l2 -2zm1259 -97c58,0 111,6 161,19 50,13 94,34 131,64 38,29 67,69 89,119 22,50 33,112 33,185l0 633c-74,42 -159,70 -255,84 -96,15 -192,22 -287,22 -126,0 -217,-29 -273,-88 -56,-58 -84,-155 -84,-289 0,-95 33,-166 100,-211 67,-46 167,-68 298,-66l368 0 0 -80c0,-55 -7,-102 -22,-139 -15,-38 -37,-68 -64,-90 -28,-22 -60,-39 -98,-49 -37,-10 -78,-15 -123,-15 -56,0 -116,6 -180,19 -63,12 -128,28 -195,48l-30 -89c71,-21 142,-39 215,-54 73,-14 144,-21 214,-21l2 -2zm-78 552c-95,0 -166,17 -211,51 -46,34 -69,82 -69,146 0,107 20,181 58,223 38,42 101,63 187,63 71,0 140,-5 208,-15 68,-10 130,-31 186,-61l0 -411 -359 4zm1737 487c-68,35 -137,59 -208,72 -71,13 -155,20 -253,21 -74,0 -140,-9 -198,-29 -59,-19 -108,-51 -149,-96 -40,-45 -71,-104 -92,-178 -21,-73 -31,-164 -31,-273 0,-95 11,-177 32,-247 22,-69 52,-126 90,-171 38,-45 85,-78 139,-100 54,-21 113,-32 178,-32 78,0 147,6 205,18 59,13 109,28 151,45l0 -479 134 0 2 1449zm-455 -929c-107,0 -190,36 -250,107 -60,72 -90,185 -90,341 0,90 7,165 21,225 13,60 34,108 61,145 28,37 62,63 103,79 42,16 90,24 144,24 41,-2 77,-4 109,-6 31,-2 60,-6 86,-11 26,-5 51,-12 73,-20 22,-9 44,-20 66,-35l0 -791c-39,-15 -84,-29 -136,-41 -52,-11 -115,-17 -189,-17l2 0zm1257 -106c92,0 171,7 237,20 66,14 111,25 137,34l-32 93c-30,-10 -74,-21 -131,-32 -57,-12 -127,-18 -209,-18 -67,0 -122,7 -167,20 -45,13 -81,37 -107,71 -27,35 -46,83 -57,143 -10,61 -16,139 -16,234 0,91 6,166 18,225 11,60 30,107 57,142 27,36 62,60 106,74 44,14 99,21 164,21 92,0 165,-5 218,-16 54,-10 97,-21 130,-32l29 93c-26,10 -70,21 -132,34 -61,12 -142,18 -243,18 -88,0 -163,-9 -223,-28 -61,-19 -110,-50 -148,-94 -37,-44 -64,-102 -81,-174 -16,-71 -25,-160 -25,-265 0,-110 9,-201 25,-274 17,-73 44,-131 82,-174 39,-44 88,-74 149,-91 60,-18 135,-26 223,-26l-4 2zm1128 -4c58,0 112,6 162,19 49,13 93,34 131,64 37,29 67,69 88,119 22,50 33,112 33,185l0 633c-74,42 -159,70 -255,84 -96,15 -191,22 -287,22 -125,0 -216,-29 -273,-88 -56,-58 -84,-155 -84,-289 0,-95 34,-166 101,-211 67,-46 166,-68 298,-66l368 0 0 -80c0,-55 -8,-102 -23,-139 -15,-38 -36,-68 -64,-90 -27,-22 -60,-39 -97,-49 -38,-10 -79,-15 -124,-15 -56,0 -116,6 -180,19 -63,12 -128,28 -195,48l-30 -89c71,-21 143,-39 216,-54 73,-14 144,-21 213,-21l2 -2zm-78 552c-95,0 -165,17 -211,51 -45,34 -68,82 -68,146 0,107 19,181 57,223 38,42 101,63 188,63 70,0 140,-5 208,-15 67,-10 129,-31 186,-61l0 -411 -360 4zm1174 -546c85,0 159,4 220,12 62,8 110,16 146,25l-21 93c-32,-7 -76,-14 -131,-22 -56,-7 -123,-11 -203,-11 -89,0 -157,13 -201,37 -45,25 -67,67 -67,128 0,28 5,50 15,66 10,17 27,32 52,47 24,14 56,30 96,46 40,17 89,39 148,66 77,35 141,66 192,94 51,27 91,56 119,87 28,31 45,67 50,109 5,41 0,92 -16,154 -20,74 -63,125 -129,153 -66,28 -141,42 -226,42 -47,0 -94,-1 -142,-5 -49,-4 -94,-8 -137,-13 -42,-5 -79,-10 -110,-14 -31,-4 -52,-7 -62,-9l17 -95c9,1 28,4 57,8 29,3 63,7 103,11 39,5 83,9 132,12 48,4 96,6 144,6 56,0 105,-9 146,-27 41,-18 68,-51 81,-99 10,-42 14,-76 11,-103 -3,-26 -15,-51 -37,-72 -21,-22 -53,-44 -94,-65 -41,-22 -95,-48 -161,-78 -60,-28 -113,-52 -161,-72 -47,-20 -88,-41 -121,-64 -33,-22 -58,-48 -76,-78 -17,-29 -26,-68 -26,-116 0,-47 10,-87 28,-120 19,-32 46,-59 79,-79 34,-20 76,-34 124,-43 48,-9 102,-13 161,-13l0 2zm1306 17l0 100 -370 0 0 730c0,27 3,52 8,75 5,22 15,41 30,56 15,15 37,26 65,34 28,7 65,10 109,10 41,0 89,-4 145,-13l16 96c-35,6 -68,10 -99,13 -31,3 -61,4 -90,4 -115,2 -197,-21 -245,-66 -47,-45 -71,-115 -71,-209l0 -730 -171 0 0 -100 177 0 11 -292 117 0 0 292 368 0z" })))));
    var logoDark = (React__default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlSpace: "preserve", width: "188.637mm", height: "34.105mm", version: "1.1", style: {
            shapeRendering: 'geometricPrecision',
            textRendering: 'geometricPrecision',
            // imageRendering: 'optimizeQuality',
            fillRule: 'evenodd',
            clipRule: 'evenodd',
        }, viewBox: "0 0 18864 3411", xmlnsXlink: "http://www.w3.org/1999/xlink" },
        React__default.createElement("g", { id: "Layer_x0020_1" },
            React__default.createElement("metadata", { id: "CorelCorpID_0Corel-Layer" }),
            React__default.createElement("g", { id: "_533512264" },
                React__default.createElement("path", { fill: "#D92982", d: "M675 306c59,33 91,90 91,158l0 463c0,68 -32,125 -91,158 -58,34 -124,34 -182,0l-402 -232c-58,-33 -91,-90 -91,-157l0 -464c0,-1 0,-1 0,-2l0 -114c0,-43 21,-79 58,-100 36,-21 78,-21 115,0l100 58 402 232z" }),
                React__default.createElement("path", { fill: "#FFFFFF", d: "M273 2647l324 187c59,34 92,90 92,158 0,67 -33,124 -92,158l-324 187c0,0 -1,0 -1,1l-99 57c-37,21 -79,21 -115,0 -37,-22 -58,-58 -58,-100l0 -113c0,-1 0,-2 0,-2 0,-1 0,-1 0,-1l0 -374c0,-68 33,-125 91,-158 59,-34 124,-34 182,0zm1115 -1930l1438 830 100 58c37,21 58,58 58,100 0,43 -21,79 -58,100l-94 55 -4 2c-1,0 -2,1 -2,1l-402 232c-58,34 -124,34 -182,0l-1037 -598c-58,-34 -91,-91 -91,-158l0 -464 0 -116c0,-42 21,-79 58,-100 37,-21 79,-21 115,0l101 58zm-1115 643l1439 831c58,33 91,90 91,158 0,67 -33,124 -91,157l-402 232c-58,34 -124,34 -182,0l-1037 -598c-58,-34 -91,-91 -91,-158l0 -464 0 -116c0,-42 21,-78 58,-100 36,-21 78,-21 115,0l100 58z" }),
                React__default.createElement("path", { fill: "#FFFFFF", d: "M273 3337l-1 1c0,0 0,0 0,-1 1,0 1,0 1,0z" }),
                React__default.createElement("path", { fill: "#FFFFFF", d: "M4907 2450l-71 -951 -330 761 -277 0 -329 -761 -72 951 -314 0 124 -1516 353 0 377 951 377 -951 353 0 123 1516 -314 0zm1495 -39c-62,15 -129,29 -201,42 -71,13 -152,19 -241,19 -77,0 -146,-9 -208,-26 -62,-17 -115,-47 -159,-90 -44,-42 -78,-100 -102,-173 -24,-73 -36,-164 -36,-274 0,-81 4,-156 12,-224 8,-69 29,-128 63,-179 34,-51 85,-90 155,-118 69,-28 166,-42 290,-42 123,0 217,15 283,46 65,31 112,74 140,129 29,55 44,120 48,194 4,74 5,155 5,242l0 30 -704 0c3,53 9,97 18,132 8,35 23,62 43,82 20,21 47,35 81,43 34,8 79,11 134,11l32 0c61,-1 112,-5 155,-11 43,-7 83,-12 120,-15l67 182 5 0zm-223 -602c-2,-49 -5,-90 -10,-123 -5,-33 -15,-60 -28,-79 -14,-20 -34,-33 -60,-41 -26,-8 -61,-12 -104,-12 -50,0 -91,4 -120,13 -30,8 -52,22 -67,42 -15,19 -26,46 -31,79 -5,33 -8,74 -9,121l429 0zm1187 -444l0 208 -310 0 0 557c0,40 9,72 28,95 19,23 61,34 126,33 18,0 39,-1 60,-4 22,-2 45,-4 70,-7l30 203c-39,6 -78,11 -116,15 -38,3 -75,5 -112,5 -57,0 -109,-6 -155,-17 -47,-12 -86,-31 -119,-57 -32,-26 -57,-60 -75,-104 -18,-43 -27,-96 -27,-160l0 -557 -159 0 0 -208 174 0 30 -264 247 0 0 264 308 -2zm266 67c75,-24 153,-44 233,-60 80,-16 158,-24 233,-24 62,0 120,6 174,19 54,13 102,36 142,67 40,32 72,74 95,125 23,51 35,115 35,192l0 621c-36,19 -77,35 -122,48 -46,13 -94,24 -143,32 -50,7 -101,13 -153,17 -52,3 -103,5 -152,5 -143,0 -246,-31 -309,-94 -64,-63 -96,-159 -96,-289 0,-110 38,-187 114,-231 76,-44 185,-65 328,-64l243 0 0 -45c0,-75 -20,-127 -60,-156 -40,-29 -93,-44 -159,-44 -46,0 -98,6 -155,18 -57,11 -118,26 -183,43l-63 -182 -2 2zm399 527c-125,0 -187,44 -187,132 0,72 13,122 39,150 26,29 68,43 126,43 40,0 81,-3 122,-8 42,-5 81,-15 118,-31l0 -286 -216 0 -2 0zm1481 -1025c234,0 351,123 351,368 0,185 -65,301 -197,347 97,19 167,59 209,121 43,62 64,153 64,273 0,146 -32,250 -97,313 -65,63 -174,94 -325,94l-629 0 0 -1516 624 0zm-483 672l436 0c86,0 151,-23 195,-69 43,-45 65,-115 65,-211 0,-95 -22,-165 -65,-210 -44,-45 -109,-67 -195,-67l-436 0 0 557zm0 732l446 0c116,0 198,-24 246,-71 49,-47 73,-126 73,-239 0,-113 -24,-192 -73,-238 -48,-46 -130,-70 -246,-70l-446 0 0 618zm1634 -999c31,0 62,4 92,11 29,7 56,15 80,24 24,9 44,17 60,26 17,9 27,15 32,19l-57 85c-2,0 -10,-3 -21,-10 -12,-6 -27,-13 -46,-21 -18,-7 -39,-13 -62,-19 -24,-6 -47,-9 -72,-9 -48,0 -98,9 -152,25 -53,17 -101,35 -143,53l0 925 -134 0 0 -985c29,-15 61,-29 95,-44 35,-14 71,-27 108,-39 36,-11 74,-21 111,-28 38,-7 74,-11 109,-11l0 -2zm946 5c82,0 155,9 218,29 63,19 115,50 157,92 42,42 73,96 94,163 21,68 32,149 32,246 0,110 -11,203 -31,279 -20,75 -51,137 -92,184 -41,47 -93,81 -156,102 -63,20 -137,31 -222,31 -91,0 -168,-10 -233,-29 -64,-20 -117,-52 -158,-98 -41,-45 -71,-106 -90,-182 -19,-76 -28,-171 -28,-285 0,-98 11,-180 34,-248 22,-67 55,-121 97,-163 43,-42 96,-72 159,-91 64,-19 137,-28 219,-28l0 -2zm2 97c-63,0 -118,7 -165,21 -47,13 -86,37 -117,71 -31,34 -55,79 -70,134 -15,56 -22,126 -22,209 0,100 6,182 19,246 13,65 34,115 64,152 30,37 68,62 116,76 48,13 106,20 175,20 62,0 117,-7 163,-22 46,-16 84,-42 114,-81 29,-38 51,-89 66,-152 14,-64 21,-143 21,-239 0,-82 -7,-151 -21,-206 -15,-56 -37,-101 -68,-135 -30,-34 -68,-58 -114,-71 -47,-14 -101,-21 -163,-21l2 -2zm1259 -97c58,0 111,6 161,19 50,13 94,34 131,64 38,30 67,69 89,119 22,50 33,112 33,185l0 633c-74,42 -159,70 -255,84 -96,15 -192,22 -287,22 -126,0 -217,-29 -273,-88 -56,-58 -84,-155 -84,-289 0,-95 33,-166 100,-211 68,-46 167,-68 298,-66l368 0 0 -80c0,-55 -7,-102 -22,-139 -15,-38 -37,-68 -64,-90 -28,-22 -60,-39 -98,-49 -37,-10 -78,-15 -123,-15 -56,0 -116,6 -180,19 -63,12 -128,28 -195,48l-30 -88c71,-22 142,-40 215,-55 73,-14 144,-21 214,-21l2 -2zm-78 552c-95,0 -166,17 -211,51 -46,34 -69,82 -69,146 0,107 20,181 58,223 38,42 101,63 187,63 71,0 140,-5 208,-15 68,-10 130,-31 186,-61l0 -411 -359 4zm1737 487c-68,35 -137,59 -208,72 -71,13 -155,20 -253,21 -74,0 -140,-9 -198,-29 -59,-19 -108,-51 -149,-96 -40,-45 -71,-104 -92,-178 -21,-73 -31,-164 -31,-273 0,-95 11,-177 32,-247 22,-69 52,-126 90,-171 38,-45 85,-78 139,-99 54,-22 113,-33 178,-33 78,0 147,6 205,18 59,13 109,28 151,45l0 -479 134 0 2 1449zm-455 -929c-107,0 -190,36 -250,107 -60,72 -90,185 -90,341 0,90 7,165 21,225 14,60 34,108 62,145 27,37 61,63 102,79 42,16 90,24 144,24 41,-2 77,-4 109,-6 32,-2 60,-6 86,-11 26,-5 51,-12 73,-20 22,-9 44,-20 66,-35l0 -791c-39,-15 -84,-29 -136,-41 -52,-11 -115,-17 -189,-17l2 0zm1257 -106c92,0 171,7 237,20 66,14 111,25 137,34l-32 93c-30,-10 -74,-21 -131,-32 -57,-12 -127,-18 -209,-18 -67,0 -122,7 -167,20 -45,13 -80,37 -107,71 -27,35 -46,83 -57,143 -10,61 -16,139 -16,234 0,91 6,166 18,226 11,59 30,106 57,141 27,36 62,60 106,74 44,14 99,21 164,21 92,0 165,-5 218,-16 54,-10 97,-20 130,-32l29 93c-26,10 -70,21 -131,34 -62,12 -143,18 -244,18 -88,0 -163,-9 -223,-28 -61,-19 -110,-50 -148,-94 -37,-44 -64,-102 -81,-174 -16,-71 -25,-160 -25,-265 0,-110 9,-201 25,-274 17,-73 44,-131 82,-174 39,-44 88,-74 149,-91 61,-18 135,-26 223,-26l-4 2zm1128 -4c58,0 112,6 162,19 49,13 93,34 131,64 37,30 67,69 89,119 21,50 32,112 32,185l0 633c-74,42 -159,70 -255,84 -96,15 -191,22 -287,22 -125,0 -216,-29 -272,-88 -57,-58 -85,-155 -85,-289 0,-95 34,-166 101,-211 67,-46 166,-68 298,-66l368 0 0 -80c0,-55 -8,-102 -23,-139 -15,-38 -36,-68 -64,-90 -27,-22 -60,-39 -97,-49 -38,-10 -79,-15 -124,-15 -56,0 -116,6 -180,19 -63,12 -128,28 -194,48l-31 -88c71,-22 143,-40 216,-55 73,-14 144,-21 213,-21l2 -2zm-78 552c-95,0 -165,17 -211,51 -45,34 -68,82 -68,146 0,107 19,181 57,223 38,42 101,63 188,63 70,0 140,-5 208,-15 67,-10 130,-31 186,-61l0 -411 -360 4zm1174 -546c86,0 159,4 220,12 62,8 110,16 146,25l-21 93c-32,-7 -76,-14 -131,-22 -56,-7 -123,-10 -203,-10 -89,0 -157,12 -201,36 -45,25 -67,67 -67,128 0,28 5,50 15,66 10,17 27,32 52,47 24,14 56,30 96,46 40,17 89,39 148,66 77,35 141,66 192,94 51,27 91,56 119,87 28,31 45,67 50,109 5,41 0,92 -16,154 -20,74 -63,125 -129,153 -66,28 -141,42 -226,42 -47,0 -94,-1 -142,-5 -49,-4 -94,-8 -137,-13 -42,-5 -79,-10 -110,-14 -31,-4 -52,-7 -62,-9l17 -95c9,1 28,4 57,8 29,3 63,7 103,11 39,5 83,9 132,12 48,4 96,6 144,6 56,0 105,-9 146,-27 41,-18 68,-51 81,-99 10,-42 14,-76 11,-103 -3,-26 -15,-51 -37,-72 -21,-22 -53,-44 -94,-65 -41,-22 -95,-48 -161,-78 -60,-28 -113,-52 -161,-72 -47,-20 -88,-41 -121,-64 -33,-22 -58,-48 -76,-78 -17,-29 -26,-68 -26,-116 0,-47 10,-87 28,-120 19,-32 46,-59 80,-79 33,-20 75,-34 123,-43 48,-9 102,-13 161,-13l0 2zm1307 17l0 100 -371 0 0 730c0,27 3,52 8,75 5,22 15,41 30,56 15,15 37,26 65,34 28,7 65,10 109,10 41,0 89,-4 146,-13l15 96c-35,6 -68,10 -99,13 -31,3 -61,4 -90,4 -115,2 -197,-20 -245,-66 -47,-45 -71,-115 -71,-209l0 -730 -171 0 0 -100 177 0 11 -292 117 0 0 292 369 0z" })))));
    var logoIcon = (React__default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlSpace: "preserve", width: "63.6338mm", height: "72.7359mm", version: "1.1", style: {
            shapeRendering: 'geometricPrecision',
            textRendering: 'geometricPrecision',
            // imageRendering: 'optimizeQuality',
            fillRule: 'evenodd',
            clipRule: 'evenodd',
        }, viewBox: "0 0 6363 7274", xmlnsXlink: "http://www.w3.org/1999/xlink" },
        React__default.createElement("g", { id: "Layer_x0020_1" },
            React__default.createElement("metadata", { id: "CorelCorpID_0Corel-Layer" }),
            React__default.createElement("g", { id: "_374183336" },
                React__default.createElement("path", { fill: "#D92982", d: "M1440 652c124,72 194,193 194,337l0 989c0,144 -70,265 -194,337 -125,71 -264,71 -389,0l-857 -495c-124,-72 -194,-193 -194,-337l0 -989c0,-1 0,-2 0,-3l0 -244c0,-90 45,-168 123,-213 78,-45 168,-45 246,0l214 123 857 495z" }),
                React__default.createElement("path", { fill: "#330066", d: "M583 5645l691 399c125,72 195,193 195,337 0,143 -70,264 -195,336l-691 399c-1,1 -3,2 -4,2l-210 122c-78,45 -168,45 -246,0 -78,-46 -123,-123 -123,-213l0 -241c0,-2 0,-3 0,-5 0,0 0,-1 0,-1l0 -799c0,-143 70,-264 194,-336 125,-72 265,-72 389,0zm2376 -4116l3068 1771 213 124c79,45 123,122 123,213 0,90 -44,168 -123,213l-200 116 -10 5c-1,1 -2,2 -3,2l-857 495c-125,72 -264,72 -389,0l-2210 -1276c-125,-72 -195,-193 -195,-337l0 -989 0 -247c0,-90 45,-168 123,-213 78,-45 168,-45 246,0l214 123zm-2376 1372l3067 1771c125,72 195,193 195,337 0,143 -70,264 -195,336l-856 495c-125,72 -265,72 -389,0l-2211 -1276c-124,-72 -194,-193 -194,-337l0 -989 0 -247c0,-91 45,-168 123,-213 78,-46 168,-46 246,0l214 123z" }),
                React__default.createElement("path", { fill: "#D92982", d: "M583 7116l-4 2c1,0 1,0 1,0 1,-1 2,-1 3,-2z" })))));
    var logoIconDark = (React__default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlSpace: "preserve", width: "63.6339mm", height: "72.7359mm", version: "1.1", style: {
            shapeRendering: 'geometricPrecision',
            textRendering: 'geometricPrecision',
            // imageRendering: 'optimizeQuality',
            fillRule: 'evenodd',
            clipRule: 'evenodd',
        }, viewBox: "0 0 6363 7274", xmlnsXlink: "http://www.w3.org/1999/xlink" },
        React__default.createElement("g", { id: "Layer_x0020_1" },
            React__default.createElement("metadata", { id: "CorelCorpID_0Corel-Layer" }),
            React__default.createElement("g", { id: "_396677664" },
                React__default.createElement("path", { fill: "#D92982", d: "M1440 652c124,72 194,193 194,337l0 989c0,144 -70,265 -194,337 -125,71 -264,71 -389,0l-857 -495c-124,-72 -194,-193 -194,-337l0 -989c0,-1 0,-2 0,-3l0 -244c0,-90 45,-168 123,-213 78,-45 168,-45 246,0l214 123 857 495z" }),
                React__default.createElement("path", { fill: "#FFFFFF", d: "M583 5645l691 399c125,72 195,193 195,337 0,143 -70,264 -195,336l-691 399c-1,1 -3,2 -4,2l-210 122c-78,45 -168,45 -246,0 -78,-45 -123,-123 -123,-213l0 -241c0,-2 0,-3 0,-5 0,0 0,-1 0,-1l0 -799c0,-143 70,-264 194,-336 125,-72 265,-72 389,0zm2376 -4116l3068 1771 213 124c79,45 123,122 123,213 0,90 -44,168 -123,213l-200 116 -10 5c-1,1 -2,2 -3,2l-857 495c-125,72 -264,72 -389,0l-2210 -1276c-125,-72 -195,-193 -195,-337l0 -989 0 -247c0,-90 45,-168 123,-213 78,-45 168,-45 246,0l214 123zm-2376 1372l3067 1771c125,72 195,193 195,337 0,143 -70,264 -195,336l-856 495c-125,72 -265,72 -389,0l-2211 -1276c-124,-72 -194,-193 -194,-337l0 -989 0 -247c0,-91 45,-168 123,-213 78,-46 168,-46 246,0l214 123z" }),
                React__default.createElement("path", { fill: "#FFFFFF", d: "M583 7116l-4 2c1,0 1,0 1,0 1,-1 2,-1 3,-2z" })))));
    var _e = useState(logo), selectedLogo = _e[0], setSelectedLogo = _e[1];
    useEffect(function () {
        setSelectedLogo(function () {
            if (icon) {
                return dark ? logoIconDark : logoIcon;
            }
            else {
                return dark ? logoDark : logo;
            }
        });
        // eslint-disable-next-line
    }, [icon, dark]);
    return (React__default.createElement(LogoWrap, { size: size, icon: icon, width: width, height: height }, selectedLogo));
};

var PageTitle = function (_a) {
    var title = _a.title;
    var constructedTitle = [title, process.env.REACT_APP_SITE_TITLE]
        .filter(function (value) { return !!value; })
        .join(' - ');
    return constructedTitle ? (React__default.createElement(Helmet, { defer: false },
        React__default.createElement("title", null, constructedTitle))) : (React__default.createElement(React__default.Fragment, null));
};

var PaginationListWrap = styled(Box)(templateObject_1$p || (templateObject_1$p = __makeTemplateObject(["\n  align-items: center;\n"], ["\n  align-items: center;\n"])));
var PaginationListItem = styled.div(templateObject_2$c || (templateObject_2$c = __makeTemplateObject(["\n  cursor: pointer;\n  ", ";\n  ", ";\n  background-color: ", ";\n  transition: background-color 300ms ease, color 300ms ease;\n\n  &:not(.no-hover):hover,\n  &:not(.no-hover).active {\n    color: ", ";\n    background-color: ", ";\n  }\n"], ["\n  cursor: pointer;\n  ", ";\n  ", ";\n  background-color: ", ";\n  transition: background-color 300ms ease, color 300ms ease;\n\n  &:not(.no-hover):hover,\n  &:not(.no-hover).active {\n    color: ", ";\n    background-color: ", ";\n  }\n"])), gapStyle('padding', { horizontal: '3', vertical: '2' }), radiusStyle('default'), normaliseColor('white'), normaliseColor('white'), normaliseColor('secondary'));
var PaginationArrowWrap = styled(Box)(templateObject_3$8 || (templateObject_3$8 = __makeTemplateObject(["\n  cursor: pointer;\n  ", "\n  ", "\n  .mb-icon {\n    color: ", ";\n  }\n"], ["\n  cursor: pointer;\n  ",
    "\n  ", "\n  .mb-icon {\n    color: ",
    ";\n  }\n"])), function (_a) {
    var position = _a.position;
    if (position === 'left') {
        return gapStyle('margin', { right: '2' });
    }
    if (position === 'right') {
        return gapStyle('margin', { left: '2' });
    }
}, function (_a) {
    var disabled = _a.disabled;
    return disabled && "pointer-events: none;";
}, function (_a) {
    var disabled = _a.disabled;
    return disabled ? normaliseColor('coolGray-200') : normaliseColor('primary');
});
var templateObject_1$p, templateObject_2$c, templateObject_3$8;

var totalNumbers = 7;
var totalBlocks = 9;
var pageNeighbours = 2;
var range = function (from, to, step) {
    if (step === void 0) { step = 1; }
    var i = from;
    var range = [];
    while (i <= to) {
        range.push(i);
        i += step;
    }
    return range;
};
var Pagination = function (_a) {
    var totalRecords = _a.totalRecords, pageLimit = _a.pageLimit, currentPage = _a.page, setCurrentPage = _a.setPage;
    var _b = useState([]), pages = _b[0], setPages = _b[1];
    var _c = useState(0), totalPages = _c[0], setTotalPages = _c[1];
    useEffect(function () {
        setTotalPages(Math.ceil(totalRecords / pageLimit));
    }, [pageLimit, totalRecords]);
    useEffect(function () {
        if (currentPage && totalPages) {
            var pageData = [];
            if (totalPages > totalBlocks) {
                var pages_1 = [];
                var leftBound = currentPage - pageNeighbours;
                var rightBound = currentPage + pageNeighbours;
                var beforeLastPage = totalPages - 1;
                var startPage = leftBound > 2 ? leftBound : 2;
                var endPage = rightBound < beforeLastPage ? rightBound : beforeLastPage;
                pages_1 = range(startPage, endPage);
                var pagesCount = pages_1.length;
                var singleSpillOffset = totalNumbers - pagesCount - 1;
                var leftSpill = startPage > 2;
                var rightSpill = endPage < beforeLastPage;
                var leftSpillPage = 'ellipsis_gap';
                var rightSpillPage = 'ellipsis_gap';
                if (leftSpill && !rightSpill) {
                    var extraPages = range(startPage - singleSpillOffset, startPage - 1);
                    pages_1 = __spreadArrays([leftSpillPage], extraPages, pages_1);
                }
                else if (!leftSpill && rightSpill) {
                    var extraPages = range(endPage + 1, endPage + singleSpillOffset);
                    pages_1 = __spreadArrays(pages_1, extraPages, [rightSpillPage]);
                }
                else if (leftSpill && rightSpill) {
                    pages_1 = __spreadArrays([leftSpillPage], pages_1, [rightSpillPage]);
                }
                pageData = __spreadArrays([1], pages_1, [totalPages]);
            }
            else {
                pageData = range(1, totalPages);
            }
            setPages(pageData);
        }
    }, [totalPages, currentPage]);
    var gotoPage = useCallback(function (page) {
        if (pages) {
            var currentPage_1 = Math.max(1, Math.min(page, totalPages));
            setCurrentPage(currentPage_1);
        }
    }, [pages, totalPages, setCurrentPage]);
    var handleClick = useCallback(function (page, evt) {
        evt.preventDefault();
        gotoPage(page);
    }, [gotoPage]);
    return (React__default.createElement(Box, { width: "full", justify: "center" },
        React__default.createElement(Card, null, pages && (React__default.createElement(PaginationListWrap, null,
            React__default.createElement(PaginationArrowWrap, { position: "left", disabled: currentPage === 1, onClick: function (e) {
                    if (currentPage !== 1) {
                        handleClick(currentPage - 1, e);
                    }
                } },
                React__default.createElement(IoIosArrowBack, { size: "15" })),
            pages.map(function (page, index) {
                if (page === 'ellipsis_gap' || page === 'ellipsis_gap') {
                    return (React__default.createElement(PaginationListItem, { key: page + index, className: "no-hover" }, "..."));
                }
                return (React__default.createElement(PaginationListItem, { key: page, className: currentPage === page ? 'active' : '', onClick: function (e) { return handleClick(page, e); } }, page));
            }),
            React__default.createElement(PaginationArrowWrap, { position: "right", disabled: currentPage === totalPages, onClick: function (e) {
                    if (currentPage !== totalPages) {
                        handleClick(currentPage + 1, e);
                    }
                } },
                React__default.createElement(IoIosArrowForward, { size: "15" })))))));
};

var StyledPill = styled.div(templateObject_8$1 || (templateObject_8$1 = __makeTemplateObject(["\n  display: inline-flex;\n  align-items: center;\n  align-content: center;\n  text-align: ", ";\n  font-size: ", ";\n  line-height: 1.75em;\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  overflow: hidden;\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n"], ["\n  display: inline-flex;\n  align-items: center;\n  align-content: center;\n  text-align: ", ";\n  font-size: ", ";\n  line-height: 1.75em;\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  overflow: hidden;\n\n  ",
    ";\n\n  ",
    ";\n\n  ",
    ";\n\n  ",
    ";\n\n  ",
    ";\n\n  ",
    ";\n\n  ",
    ";\n"])), function (props) { return props.align; }, function (props) { return props.theme.fonts.size[props.sizeProp]; }, function (props) { return props.displayProp && "display: " + props.displayProp + ";"; }, function (props) { return weightStyle(props.weight); }, function (props) { return gapStyle('margin', props.marginProp); }, radiusStyle('full'), function (props) {
    return props.pillTheme === 'default' && css(templateObject_1$q || (templateObject_1$q = __makeTemplateObject(["\n      background-color: ", ";\n      color: ", ";\n    "], ["\n      background-color: ", ";\n      color: ", ";\n    "])), normaliseColor('coolGray-200'), normaliseColor('coolGray-600'));
}, function (props) {
    return props.pillTheme === 'primary' && css(templateObject_2$d || (templateObject_2$d = __makeTemplateObject(["\n      background-color: ", ";\n      color: ", ";\n    "], ["\n      background-color: ", ";\n      color: ", ";\n    "])), normaliseColor('pink-100'), normaliseColor('pink-500'));
}, function (props) {
    return props.pillTheme === 'secondary' && css(templateObject_3$9 || (templateObject_3$9 = __makeTemplateObject(["\n      background-color: ", ";\n      color: ", ";\n    "], ["\n      background-color: ", ";\n      color: ", ";\n    "])), normaliseColor('purple-100'), normaliseColor('purple-500'));
}, function (props) {
    return props.pillTheme === 'success' && css(templateObject_4$7 || (templateObject_4$7 = __makeTemplateObject(["\n      background-color: ", ";\n      color: ", ";\n    "], ["\n      background-color: ", ";\n      color: ", ";\n    "])), normaliseColor('green-200'), normaliseColor('green-700'));
}, function (props) {
    return props.pillTheme === 'info' && css(templateObject_5$6 || (templateObject_5$6 = __makeTemplateObject(["\n      background-color: ", ";\n      color: ", ";\n    "], ["\n      background-color: ", ";\n      color: ", ";\n    "])), normaliseColor('blue-200'), normaliseColor('blue-700'));
}, function (props) {
    return props.pillTheme === 'warning' && css(templateObject_6$3 || (templateObject_6$3 = __makeTemplateObject(["\n      background-color: ", ";\n      color: ", ";\n    "], ["\n      background-color: ", ";\n      color: ", ";\n    "])), normaliseColor('orange-200'), normaliseColor('orange-700'));
}, function (props) {
    return props.pillTheme === 'danger' && css(templateObject_7$2 || (templateObject_7$2 = __makeTemplateObject(["\n      background-color: ", ";\n      color: ", ";\n    "], ["\n      background-color: ", ";\n      color: ", ";\n    "])), normaliseColor('red-200'), normaliseColor('red-700'));
});
var StyledPillTitle = styled.span(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n  display: inline-block;\n  ", ";\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n"], ["\n  display: inline-block;\n  ", ";\n  ", ";\n\n  ",
    ";\n\n  ",
    ";\n\n  ",
    ";\n\n  ",
    ";\n\n  ",
    ";\n\n  ",
    ";\n\n  ",
    ";\n"])), weightStyle('bold'), gapStyle('padding', { left: '3', right: '2' }), function (props) {
    return props.pillTheme === 'default' && css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n      background-color: ", ";\n      color: ", ";\n    "], ["\n      background-color: ", ";\n      color: ", ";\n    "])), normaliseColor('coolGray-600'), normaliseColor('white'));
}, function (props) {
    return props.pillTheme === 'primary' && css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n      background-color: ", ";\n      color: ", ";\n    "], ["\n      background-color: ", ";\n      color: ", ";\n    "])), normaliseColor('pink-500'), normaliseColor('white'));
}, function (props) {
    return props.pillTheme === 'secondary' && css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n      background-color: ", ";\n      color: ", ";\n    "], ["\n      background-color: ", ";\n      color: ", ";\n    "])), normaliseColor('purple-500'), normaliseColor('white'));
}, function (props) {
    return props.pillTheme === 'success' && css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n      background-color: ", ";\n      color: ", ";\n    "], ["\n      background-color: ", ";\n      color: ", ";\n    "])), normaliseColor('green-500'), normaliseColor('white'));
}, function (props) {
    return props.pillTheme === 'info' && css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n      background-color: ", ";\n      color: ", ";\n    "], ["\n      background-color: ", ";\n      color: ", ";\n    "])), normaliseColor('blue-500'), normaliseColor('white'));
}, function (props) {
    return props.pillTheme === 'warning' && css(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n      background-color: ", ";\n      color: ", ";\n    "], ["\n      background-color: ", ";\n      color: ", ";\n    "])), normaliseColor('orange-500'), normaliseColor('white'));
}, function (props) {
    return props.pillTheme === 'danger' && css(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n      background-color: ", ";\n      color: ", ";\n    "], ["\n      background-color: ", ";\n      color: ", ";\n    "])), normaliseColor('red-700'), normaliseColor('white'));
});
var StyledPillValue = styled.span(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n  display: inline-block;\n  ", ";\n"], ["\n  display: inline-block;\n  ",
    ";\n"])), function (_a) {
    var pillTitle = _a.pillTitle;
    return gapStyle('padding', { left: '2', right: pillTitle ? '3' : '2' });
});
var templateObject_1$q, templateObject_2$d, templateObject_3$9, templateObject_4$7, templateObject_5$6, templateObject_6$3, templateObject_7$2, templateObject_8$1, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17;

var Pill = function (_a) {
    var children = _a.children, color = _a.color, _b = _a.size, size = _b === void 0 ? 'xs' : _b, _c = _a.margin, margin = _c === void 0 ? {
        right: '2',
    } : _c, _d = _a.theme, theme = _d === void 0 ? 'default' : _d, title = _a.title, _e = _a.weight, weight = _e === void 0 ? 'medium' : _e, _f = _a.align, align = _f === void 0 ? 'left' : _f;
    return (React__default.createElement(StyledPill, { colorProp: color, sizeProp: size, marginProp: margin, pillTheme: theme, weight: weight, align: align },
        title && React__default.createElement(StyledPillTitle, { pillTheme: theme }, title),
        React__default.createElement(StyledPillValue, { pillTitle: title }, children)));
};

var Auth0Context = createContext({});
var useAuth0 = function () { return useContext(Auth0Context); };
var Auth0Provider = function (_a) {
    var children = _a.children;
    var config = {
        audience: 'https://users.metabroadcast.com/api/',
        clientID: '7IBjMcYmIP_6X3Sy39NuCY0RG33DZMRu',
        domain: 'auth.metabroadcast.com',
        redirectUri: window.location.origin + "/callback",
        responseType: 'token id_token',
    };
    var auth0Client = new WebAuth(config);
    var _b = useCookies(), cookies = _b[0], setCookie = _b[1], removeCookie = _b[2];
    var _c = useState(), userProfile = _c[0], setuserProfile = _c[1];
    useEffect(function () {
        getUserProfile();
        // eslint-disable-next-line
    }, [cookies]);
    var isAuthenticated = function () {
        var accessToken = cookies.mbst_access_token;
        if (accessToken) {
            var decodedToken = jwt_decode(accessToken);
            if (decodedToken.iss !== 'https://auth.metabroadcast.com/') {
                return false;
            }
            return new Date().getTime() < parseInt(cookies.mbst_expires_at);
        }
        else {
            return false;
        }
    };
    var loginUser = function (email, password, cb) {
        auth0Client.login({
            email: email,
            password: password,
            realm: 'Username-Password-Authentication',
            audience: 'https://users.metabroadcast.com/api/',
        }, cb);
    };
    var logoutUser = function () {
        removeCookie('mbst_access_token', {
            path: '/',
            domain: 'metabroadcast.com',
        });
        removeCookie('mbst_id_token', {
            path: '/',
            domain: 'metabroadcast.com',
        });
        removeCookie('mbst_expires_at', {
            path: '/',
            domain: 'metabroadcast.com',
        });
        setuserProfile(false);
        history.push('/login');
    };
    var setSession = useCallback(function (authResult) {
        var expiresAt = JSON.stringify(authResult.expiresIn * 1000 + new Date().getTime());
        setCookie('mbst_access_token', authResult.accessToken, {
            path: '/',
            domain: 'metabroadcast.com',
        });
        setCookie('mbst_id_token', authResult.idToken, {
            path: '/',
            domain: 'metabroadcast.com',
        });
        setCookie('mbst_expires_at', expiresAt, {
            path: '/',
            domain: 'metabroadcast.com',
        });
        return;
    }, [setCookie]);
    var handleAuthentication = useCallback(function () {
        return new Promise(function (resolve, reject) {
            auth0Client.parseHash(function (err, authResult) {
                if (err)
                    return reject(err);
                if (!authResult || !authResult.idToken) {
                    return reject(err);
                }
                setSession(authResult);
                if (window.parent) {
                    window.parent.postMessage('loggedIn', '*');
                }
                resolve();
            });
        });
    }, [auth0Client, setSession]);
    var getUserProfile = function () { return __awaiter(void 0, void 0, void 0, function () {
        var res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!isAuthenticated()) {
                        return [2 /*return*/, false];
                    }
                    if (!!userProfile) return [3 /*break*/, 2];
                    return [4 /*yield*/, fetch("https://admin-backend.metabroadcast.com/1/user", {
                            credentials: 'include',
                        })];
                case 1:
                    res = _a.sent();
                    res
                        .json()
                        .then(function (data) {
                        if (data.status !== 401) {
                            data.isMbst = data.groups.some(function (group) { return group.id === 'jky'; }); // Admin app used to grant access to various frontend tools
                            data.groups = sortGroups(data.groups);
                            setuserProfile(data);
                        }
                    })
                        .catch(function (err) {
                        console.log(err);
                    });
                    _a.label = 2;
                case 2: return [2 /*return*/, userProfile];
            }
        });
    }); };
    var resetPassword = function (email, cb) {
        auth0Client.changePassword({
            connection: 'Username-Password-Authentication',
            email: email,
        }, cb);
    };
    var registerUser = function (data, cb) {
        var userData = {
            connection: 'Username-Password-Authentication',
            email: data.email,
            password: data.password,
        };
        fetch(process.env.REACT_APP_ADMIN_BACKEND + "/1/user", {
            credentials: 'include',
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(userData),
        })
            .then(function (response) {
            if (!response.ok) {
                throw response;
            }
            return response.json();
        })
            .then(function (data) {
            cb(null, data);
        })
            .catch(function (err) {
            cb(err, null);
        });
    };
    var sortGroups = function (groups) {
        var blacklist = [
            'admins',
            'bt-blackout',
            'metabroadcast',
            'youview-feeds',
        ];
        return groups
            .filter(function (group) { return !blacklist.includes(group.id); })
            .sort(function (a, b) { return a.name.localeCompare(b.name); });
    };
    var configObject = {
        cookies: cookies,
        handleAuthentication: handleAuthentication,
        isAuthenticated: isAuthenticated,
        loginUser: loginUser,
        logoutUser: logoutUser,
        getUserProfile: getUserProfile,
        userProfile: userProfile,
        resetPassword: resetPassword,
        registerUser: registerUser,
    };
    return (React__default.createElement(Auth0Context.Provider, { value: configObject }, children));
};

var ApplicationContext = createContext({});
var useApplications = function () { return useContext(ApplicationContext); };
var ApplicationProvider = function (_a) {
    var children = _a.children;
    var userProfile = useAuth0().userProfile;
    var _b = useCookies(), cookies = _b[0], setCookie = _b[1];
    var _c = useState(), selectedApplication = _c[0], setSelectedApplication = _c[1];
    var pathname = useLocation().pathname;
    var userApp = pathname.split('/')[1];
    var initUserApplication = useCallback(function () {
        if (userProfile) {
            if (userApp) {
                var canUseGroup = userProfile.groups.some(function (g) { return g.id === userApp; });
                if (canUseGroup) {
                    getUserApplication(userApp);
                    return;
                }
            }
            if (cookies.mbst_selected_app) {
                var cookie_1 = cookies.mbst_selected_app;
                if (typeof cookies.mbst_selected_app === 'object') {
                    cookie_1 = cookies.mbst_selected_app.id;
                }
                var canUseGroup = userProfile.groups.some(function (group) { return group.id === cookie_1; });
                if (canUseGroup) {
                    setUserApplication(cookie_1);
                    return;
                }
            }
            var firstGroup = userProfile.groups[0];
            if (firstGroup) {
                setUserApplication(firstGroup.id);
                return;
            }
        }
        // eslint-disable-next-line
    }, [userProfile]);
    useEffect(function () {
        initUserApplication();
        // eslint-disable-next-line
    }, [initUserApplication]);
    var setAppCookie = useCallback(function (app) {
        setCookie('mbst_selected_app', app, {
            path: '/',
            domain: 'metabroadcast.com',
        });
    }, [setCookie]);
    var getUserApplication = useCallback(function (appId) { return __awaiter(void 0, void 0, void 0, function () {
        var res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch("https://admin-backend.metabroadcast.com/1/applications/" + appId, {
                        credentials: 'include',
                    })];
                case 1:
                    res = _a.sent();
                    res
                        .json()
                        .then(function (data) {
                        if (data.status !== 401) {
                            var app = __assign({}, data.application);
                            var barbRoles = data.application.roles.filter(function (role) {
                                if (role.includes('shaman.editor') ||
                                    role.includes('shaman.content-provider') ||
                                    role.includes('shaman.inspector')) {
                                    return role;
                                }
                            })[0];
                            app.barbRole =
                                barbRoles && barbRoles.length ? barbRoles.split('.')[1] : null;
                            var broadcasterRole = data.application.roles.filter(function (role) {
                                return role.includes('shaman.barb.broadcastergroup');
                            });
                            app.broadcasterId =
                                broadcasterRole && broadcasterRole.length
                                    ? broadcasterRole[0].split('.').slice(-1)[0]
                                    : null;
                            setSelectedApplication(app);
                        }
                    })
                        .catch(function (err) {
                        console.log(err);
                    });
                    return [2 /*return*/];
            }
        });
    }); }, [setSelectedApplication]);
    var setUserApplication = useCallback(function (app) {
        setAppCookie(app);
        var path = pathname.split('/');
        path[1] = app;
        history.push(path.join('/'));
        getUserApplication(app);
    }, [setAppCookie, pathname, getUserApplication]);
    var configObject = {
        selectedApplication: selectedApplication,
        setUserApplication: setUserApplication,
    };
    return (React__default.createElement(ApplicationContext.Provider, { value: configObject }, children));
};

var BroadcasterGroupsContext = createContext({});
var useBroadcasterGroups = function () { return useContext(BroadcasterGroupsContext); };
var BroadcasterGroupsProvider = function (_a) {
    var children = _a.children;
    var selectedApplication = useApplications().selectedApplication;
    var _b = useState(), broadcasterGroups = _b[0], setBroadcasterGroups = _b[1];
    useEffect(function () {
        getBroadcasterGroups();
        // eslint-disable-next-line
    }, []);
    var getBroadcasterGroups = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch(process.env.REACT_APP_ADMIN_BACKEND + "/1/applications/" + selectedApplication.id + "/broadcastersList", {
                        credentials: 'include',
                    })];
                case 1:
                    res = _a.sent();
                    res
                        .json()
                        .then(function (data) {
                        if (data.status !== 401) {
                            setBroadcasterGroups(data.broadcasterGroups);
                        }
                    })
                        .catch(function (err) {
                        console.log(err);
                    });
                    return [2 /*return*/];
            }
        });
    }); }, [setBroadcasterGroups, selectedApplication.id]);
    var configObject = {
        broadcasterGroups: broadcasterGroups,
    };
    return (React__default.createElement(BroadcasterGroupsContext.Provider, { value: configObject }, children));
};

var StationCodesContext = createContext({});
var useStationCodes = function () { return useContext(StationCodesContext); };
var StationCodesProvider = function (_a) {
    var children = _a.children;
    var selectedApplication = useApplications().selectedApplication;
    var _b = useState(), stationCodes = _b[0], setStationCodes = _b[1];
    var _c = useState(), stationCodeGroups = _c[0], setStationCodeGroups = _c[1];
    useEffect(function () {
        getStationCodes();
        getStationCodeGroups();
        // eslint-disable-next-line
    }, []);
    var getStationCodes = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch(process.env.REACT_APP_ADMIN_BACKEND + "/1/applications/" + selectedApplication.id + "/station_codes", {
                        credentials: 'include',
                    })];
                case 1:
                    res = _a.sent();
                    res
                        .json()
                        .then(function (data) {
                        if (data.status !== 401) {
                            setStationCodes(data.stations.map(function (sc) {
                                return {
                                    id: sc.stationCode,
                                    value: sc.stationName,
                                };
                            }));
                        }
                    })
                        .catch(function (err) {
                        console.log(err);
                    });
                    return [2 /*return*/];
            }
        });
    }); }, [setStationCodes, selectedApplication.id]);
    var getStationCodeGroups = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch(process.env.REACT_APP_ADMIN_BACKEND + "/1/applications/" + selectedApplication.id + "/station_code_groups", {
                        credentials: 'include',
                    })];
                case 1:
                    res = _a.sent();
                    res
                        .json()
                        .then(function (data) {
                        if (data.status !== 401) {
                            setStationCodeGroups(data.station_groups);
                        }
                    })
                        .catch(function (err) {
                        console.log(err);
                    });
                    return [2 /*return*/];
            }
        });
    }); }, [setStationCodeGroups, selectedApplication.id]);
    var configObject = {
        stationCodes: stationCodes,
        stationCodeGroups: stationCodeGroups,
    };
    return (React__default.createElement(StationCodesContext.Provider, { value: configObject }, children));
};

var GenresContext = createContext({});
var useGenres = function () { return useContext(GenresContext); };
var GenresProvider = function (_a) {
    var children = _a.children;
    var selectedApplication = useApplications().selectedApplication;
    var _b = useState({}), genres = _b[0], setGenres = _b[1];
    var constructUrl = useCallback(function (_a) {
        var version = _a.version, versionId = _a.versionId, genreId = _a.genreId;
        var url = process.env.REACT_APP_ADMIN_BACKEND + "/1/applications/" + selectedApplication.id + "/genres";
        if (version && versionId) {
            return url + "/version/" + versionId;
        }
        if (genreId) {
            if (version) {
                url = url + "/" + genreId + "/version/most_recent";
            }
        }
        return url;
    }, [selectedApplication.id]);
    var getGenres = useCallback(function (_a) {
        var version = _a.version, versionId = _a.versionId, genreId = _a.genreId;
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_b) {
                return [2 /*return*/, new Promise(function (resolve) {
                        return __awaiter(this, void 0, void 0, function () {
                            var res;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, CachedFetch(constructUrl({
                                            version: version,
                                            versionId: versionId,
                                            genreId: genreId,
                                        }), {
                                            credentials: 'include',
                                        })];
                                    case 1:
                                        res = _a.sent();
                                        res
                                            .json()
                                            .then(function (data) {
                                            if (data.status !== 401) {
                                                setGenres(function (genres) {
                                                    var newGenres = __assign({}, genres);
                                                    newGenres[version ? versionId : 'latest'] = data.genres;
                                                    return newGenres;
                                                });
                                                return resolve(data.genres);
                                            }
                                        })
                                            .catch(function (err) {
                                            console.log(err);
                                        });
                                        return [2 /*return*/];
                                }
                            });
                        });
                    })];
            });
        });
    }, [constructUrl]);
    var getTreeFromGenreVersion = useCallback(function (genreId) { return __awaiter(void 0, void 0, void 0, function () {
        var res, data, error, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, fetch(constructUrl({
                            version: true,
                            versionId: '',
                            genreId: genreId,
                        }), {
                            credentials: 'include',
                        })];
                case 1:
                    res = _a.sent();
                    return [4 /*yield*/, res.json()];
                case 2:
                    data = _a.sent();
                    if (res.status >= 400 && res.status < 600) {
                        error = new Error(res.statusText || res.status.toString());
                        error.message = data;
                        throw error;
                    }
                    if (data.is_latest_tree_version) {
                        return [2 /*return*/, 'latest'];
                    }
                    else {
                        if (!genres[data.tree_version]) {
                            getGenres({
                                version: true,
                                versionId: data.tree_version,
                            });
                        }
                        return [2 /*return*/, data.tree_version];
                    }
                case 3:
                    error_1 = _a.sent();
                    console.log(error_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [constructUrl, genres, getGenres]);
    var getGenresFromTreeVersion = useCallback(function (treeVersionId) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            try {
                if (genres[treeVersionId]) {
                    return [2 /*return*/, genres[treeVersionId]];
                }
                return [2 /*return*/, getGenres({
                        version: true,
                        versionId: treeVersionId,
                    })];
            }
            catch (error) {
                console.log(error);
            }
            return [2 /*return*/];
        });
    }); }, [genres, getGenres]);
    useEffect(function () {
        getGenres({
            version: false,
        });
    }, [getGenres]);
    return (React__default.createElement(GenresContext.Provider, { value: {
            genres: genres,
            getTreeFromGenreVersion: getTreeFromGenreVersion,
            getGenresFromTreeVersion: getGenresFromTreeVersion,
        } }, children));
};

var PrivateRoute = function (_a) {
    var isMbst = _a.isMbst, role = _a.role, children = _a.children, rest = __rest(_a, ["isMbst", "role", "children"]);
    var userProfile = useAuth0().userProfile;
    var selectedApplication = useApplications().selectedApplication;
    return userProfile && selectedApplication ? (React__default.createElement(Route, __assign({}, rest, { render: function () {
            var hasAccess = true;
            if (isMbst) {
                if (!userProfile.isMbst) {
                    hasAccess = false;
                }
            }
            if (role) {
                var hasRole = selectedApplication.roles.includes(role);
                if (!hasRole) {
                    hasAccess = false;
                }
            }
            return hasAccess ? (children) : (React__default.createElement(React__default.Fragment, null,
                React__default.createElement(Box, { width: "full", height: "full", align: "center", justify: "center", direction: "column" },
                    React__default.createElement(Heading, null, "No Access"),
                    React__default.createElement(Text, null, "You don't have access to view this page"))));
        } }))) : null;
};

var RetryableLoadingSpinner = function (_a) {
    var failed = _a.failed, failedMessage = _a.failedMessage, retry = _a.retry, spinnerSize = _a.spinnerSize, spinnerColors = _a.spinnerColors;
    return (React__default.createElement(Box, { height: "full", width: "full", margin: "4" },
        React__default.createElement(Box, { width: "full", direction: "column", align: "center", justify: "center" }, failed ? (React__default.createElement(React__default.Fragment, null,
            failedMessage && (React__default.createElement(Box, { padding: { vertical: 2 } },
                React__default.createElement(Text, null, failedMessage))),
            React__default.createElement(Box, { padding: { vertical: 2 } },
                React__default.createElement(Button, { onClick: retry }, "Retry")))) : (React__default.createElement(LoadingSpinner, { size: spinnerSize, colors: spinnerColors })))));
};

var StyledSelectDropdownWrapper = styled.div(templateObject_1$r || (templateObject_1$r = __makeTemplateObject(["\n  position: relative;\n  width: 100%;\n  ", ";\n  max-width: ", "};\n  ", ";\n  ", ";\n"], ["\n  position: relative;\n  width: 100%;\n  ", ";\n  max-width: ",
    "};\n  ", ";\n  ", ";\n"])), function (props) { return props.flex && "flex: " + props.flex; }, function (props) {
    return (props.widthProp && props.theme.width[props.widthProp]) ||
        props.widthProp;
}, function (props) { return props.padding && gapStyle('padding', props.padding); }, function (props) { return props.margin && gapStyle('margin', props.margin); });
var templateObject_1$r;

var customStyles = {
    container: function (provided) { return (__assign(__assign({}, provided), { flex: '1' })); },
    control: function (provided, state) { return (__assign(__assign({}, provided), { '&:hover': {
            borderColor: state.isFocused ? normaliseColor('pink-500') : "transparent",
        }, backgroundColor: normaliseColor('coolGray-100'), borderColor: state.isFocused ? normaliseColor('pink-500') : "transparent", boxShadow: state.isFocused
            ? "rgb(251, 234, 243) 0px 0px 0px 3px"
            : "transparent 0px 0px 0px 0px" })); },
    option: function (provided, state) { return (__assign(__assign({}, provided), { '&:hover': {
            backgroundColor: normaliseColor('pink-200'),
        }, backgroundColor: state.isSelected
            ? normaliseColor('pink-500')
            : "transparent", color: state.isSelected
            ? normaliseColor('white')
            : normaliseColor('coolGray-700') })); },
};
var SelectDropDown = function (_a) {
    var label = _a.label, placeholder = _a.placeholder, padding = _a.padding, margin = _a.margin, _b = _a.width, width = _b === void 0 ? 'full' : _b, selectedOption = _a.selectedOption, options = _a.options, onChange = _a.onChange;
    return (React__default.createElement(StyledSelectDropdownWrapper, { padding: padding, margin: margin, widthProp: width },
        label && (React__default.createElement(Label, { color: "coolGray-700", weight: "medium", margin: { bottom: '2' } }, label)),
        React__default.createElement(Select, { styles: customStyles, value: selectedOption, onChange: function (newVal) { return onChange(newVal); }, options: options, placeholder: placeholder })));
};

var StyledSelectWrapper = styled.div(templateObject_1$s || (templateObject_1$s = __makeTemplateObject(["\n  display: flex;\n  position: relative;\n  width: 100%;\n  ", ";\n  max-width: ", "};\n  ", ";\n  ", ";\n\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  display: flex;\n  position: relative;\n  width: 100%;\n  ", ";\n  max-width: ",
    "};\n  ",
    ";\n  ", ";\n\n  ",
    ";\n  ",
    ";\n  ",
    ";\n  ",
    ";\n"])), function (props) { return props.flex && "flex: " + props.flex; }, function (props) {
    return (props.widthProp && props.theme.width[props.widthProp]) ||
        props.widthProp;
}, function (props) {
    return props.minWidthProp &&
        "min-width: " + (props.theme.width[props.minWidthProp] ||
            props.minWidthProp);
}, function (props) { return props.padding && gapStyle('padding', props.padding); }, function (_a) {
    var labelPosition = _a.labelPosition;
    return labelPosition === 'top' &&
        "\n      flex-direction: column;\n    ";
}, function (_a) {
    var labelPosition = _a.labelPosition;
    return labelPosition === 'bottom' &&
        "\n      flex-direction: column-reverse;\n    ";
}, function (_a) {
    var labelPosition = _a.labelPosition;
    return labelPosition === 'left' &&
        "\n      align-items: center;\n      flex-direction: row;\n    ";
}, function (_a) {
    var labelPosition = _a.labelPosition;
    return labelPosition === 'right' &&
        "\n      align-items: center;\n      flex-direction: row-reverse;\n    ";
});
var StyledSelect = styled.select(templateObject_2$e || (templateObject_2$e = __makeTemplateObject(["\n  flex: 1 1 40px;\n  width: 100%;\n  height: 40px; \n  outline: none;\n  ", ";\n  ", "\n  ", "\n  color: ", ";\n  font-size: ", ";\n  border: 1px solid;\n  border-color: transparent;\n  box-shadow: 0 0 0 0 transparent;\n  transition: border-color 0.3s ease, box-shadow 0.3s ease;\n\n  &:focus {\n    box-shadow: 0 0 0 3px ", ";\n    border-color: ", ";\n  }\n"], ["\n  flex: 1 1 40px;\n  width: 100%;\n  height: 40px; \n  outline: none;\n  ", ";\n  ",
    "\n  ", "\n  color: ", ";\n  font-size: ", ";\n  border: 1px solid;\n  border-color: transparent;\n  box-shadow: 0 0 0 0 transparent;\n  transition: border-color 0.3s ease, box-shadow 0.3s ease;\n\n  &:focus {\n    box-shadow: 0 0 0 3px ", ";\n    border-color: ", ";\n  }\n"])), function (props) { return "background: " + normaliseColor(props.background) + ";"; }, gapStyle('padding', {
    horizontal: '4',
    vertical: '3',
}), function (props) { return props.radiusProp && radiusStyle(props.radiusProp); }, normaliseColor('coolGray-700'), function (_a) {
    var theme = _a.theme;
    return theme.fonts.size.base;
}, normaliseColor('pink-100'), normaliseColor('pink-500'));
var SelectLabel = styled(Label)(templateObject_7$3 || (templateObject_7$3 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  ",
    ";\n  ",
    ";\n  ",
    ";\n  ",
    ";\n"])), function (_a) {
    var labelPosition = _a.labelPosition;
    return labelPosition === 'top' && css(templateObject_3$a || (templateObject_3$a = __makeTemplateObject(["\n      ", "\n    "], ["\n      ",
        "\n    "])), gapStyle('margin', {
        bottom: '2',
    }));
}, function (_a) {
    var labelPosition = _a.labelPosition;
    return labelPosition === 'bottom' && css(templateObject_4$8 || (templateObject_4$8 = __makeTemplateObject(["\n      ", "\n    "], ["\n      ",
        "\n    "])), gapStyle('margin', {
        top: '2',
    }));
}, function (_a) {
    var labelPosition = _a.labelPosition;
    return labelPosition === 'left' && css(templateObject_5$7 || (templateObject_5$7 = __makeTemplateObject(["\n      ", "\n    "], ["\n      ",
        "\n    "])), gapStyle('margin', {
        right: '2',
    }));
}, function (_a) {
    var labelPosition = _a.labelPosition;
    return labelPosition === 'right' && css(templateObject_6$4 || (templateObject_6$4 = __makeTemplateObject(["\n      ", "\n    "], ["\n      ",
        "\n    "])), gapStyle('margin', {
        left: '2',
    }));
});
var templateObject_1$s, templateObject_2$e, templateObject_3$a, templateObject_4$8, templateObject_5$7, templateObject_6$4, templateObject_7$3;

var SelectInput = function (_a) {
    var _b = _a.background, background = _b === void 0 ? 'coolGray-100' : _b, _c = _a.radius, radius = _c === void 0 ? 'default' : _c, inputRef = _a.inputRef, label = _a.label, _d = _a.labelPosition, labelPosition = _d === void 0 ? 'top' : _d, padding = _a.padding, options = _a.options, _e = _a.width, width = _e === void 0 ? 'full' : _e, minWidth = _a.minWidth, flex = _a.flex, rest = __rest(_a, ["background", "radius", "inputRef", "label", "labelPosition", "padding", "options", "width", "minWidth", "flex"]);
    return (React__default.createElement(StyledSelectWrapper, { padding: padding, labelPosition: labelPosition, widthProp: width, minWidthProp: minWidth, flex: flex },
        label && (React__default.createElement(SelectLabel, { color: "coolGray-700", weight: "medium", labelPosition: labelPosition }, label)),
        React__default.createElement(StyledSelect, __assign({}, rest, { ref: inputRef, radiusProp: radius, background: background }), options &&
            options.map(function (option) {
                return (React__default.createElement("option", { key: option.value, value: option.value }, option.label));
            }))));
};

var TagInputWrap = styled.div(templateObject_1$t || (templateObject_1$t = __makeTemplateObject(["\n  position: relative;\n  width: 100%;\n"], ["\n  position: relative;\n  width: 100%;\n"])));
var StyledTagInput = styled(TagsInput)(templateObject_2$f || (templateObject_2$f = __makeTemplateObject(["\n  width: 100%;\n  ", ";\n  ", ";\n  background: ", ";\n  color: ", ";\n  font-size: ", ";\n  border: 1px solid;\n  border-color: transparent;\n  ", "\n  box-shadow: 0 0 0 0 transparent;\n  transition: border-color 0.3s ease, box-shadow 0.3s ease;\n\n  &.react-tagsinput--focused {\n    box-shadow: 0 0 0 3px ", ";\n    border-color: ", ";\n  }\n\n  .react-tagsinput-input {\n    outline: none;\n    background: transparent;\n    border: 0;\n    color: ", ";\n    font-size: ", ";\n    width: 100%;\n    border-top: 1px solid ", ";\n    border-radius: 0;\n    padding-top: 0.75rem;\n    margin-top: 0.75rem;\n\n    &::placeholder {\n      color: ", ";\n    }\n  }\n"], ["\n  width: 100%;\n  ",
    ";\n  ", ";\n  background: ", ";\n  color: ", ";\n  font-size: ", ";\n  border: 1px solid;\n  border-color: transparent;\n  ", "\n  box-shadow: 0 0 0 0 transparent;\n  transition: border-color 0.3s ease, box-shadow 0.3s ease;\n\n  &.react-tagsinput--focused {\n    box-shadow: 0 0 0 3px ", ";\n    border-color: ", ";\n  }\n\n  .react-tagsinput-input {\n    outline: none;\n    background: transparent;\n    border: 0;\n    color: ", ";\n    font-size: ", ";\n    width: 100%;\n    border-top: 1px solid ", ";\n    border-radius: 0;\n    padding-top: 0.75rem;\n    margin-top: 0.75rem;\n\n    &::placeholder {\n      color: ", ";\n    }\n  }\n"])), gapStyle('padding', {
    horizontal: '4',
    vertical: '3',
}), radiusStyle('default'), normaliseColor('coolGray-100'), normaliseColor('coolGray-700'), function (_a) {
    var theme = _a.theme;
    return theme.fonts.size.base;
}, function (props) { return props.radiusProp && radiusStyle(props.radiusProp); }, normaliseColor('pink-100'), normaliseColor('pink-500'), normaliseColor('coolGray-700'), function (_a) {
    var theme = _a.theme;
    return theme.fonts.size.base;
}, normaliseColor('coolGray-400'), normaliseColor('coolGray-500'));
var Tag = styled.div(templateObject_3$b || (templateObject_3$b = __makeTemplateObject(["\n  background-color: ", ";\n  ", ";\n  color: ", ";\n  display: inline-flex;\n  align-items: center;\n  font-size: ", ";\n  font-weight: ", ";\n  ", "\n  ", "\n"], ["\n  background-color: ",
    ";\n  ", ";\n  color: ", ";\n  display: inline-flex;\n  align-items: center;\n  font-size: ", ";\n  font-weight: ", ";\n  ",
    "\n  ", "\n"])), function (_a) {
    var isGroup = _a.isGroup;
    return isGroup ? normaliseColor('pink-500') : normaliseColor('purple-500');
}, radiusStyle('default'), normaliseColor('white'), function (_a) {
    var theme = _a.theme;
    return theme.fonts.size.sm;
}, function (_a) {
    var theme = _a.theme;
    return theme.fonts.weights.medium;
}, gapStyle('margin', {
    bottom: '1',
    right: '1',
}), gapStyle('padding', '2'));
var TagUngroup = styled.div(templateObject_4$9 || (templateObject_4$9 = __makeTemplateObject(["\n  cursor: pointer;\n  ", "\n\n  svg {\n    display: block;\n    fill: ", ";\n    width: 12px;\n  }\n\n  &:hover {\n    svg {\n      fill: ", ";\n    }\n  }\n"], ["\n  cursor: pointer;\n  ",
    "\n\n  svg {\n    display: block;\n    fill: ", ";\n    width: 12px;\n  }\n\n  &:hover {\n    svg {\n      fill: ", ";\n    }\n  }\n"])), gapStyle('margin', {
    left: '2',
}), normaliseColor('pink-700'), normaliseColor('white'));
var TagClose = styled.div(templateObject_5$8 || (templateObject_5$8 = __makeTemplateObject(["\n  cursor: pointer;\n  font-weight: bold;\n  ", "\n  color: ", ";\n\n\n  &:hover {\n    color: ", ";\n  }\n"], ["\n  cursor: pointer;\n  font-weight: bold;\n  ",
    "\n  color: ",
    ";\n\n\n  &:hover {\n    color: ", ";\n  }\n"])), gapStyle('margin', {
    left: '2',
}), function (_a) {
    var isGroup = _a.isGroup;
    return isGroup ? normaliseColor('pink-700') : normaliseColor('red-500');
}, normaliseColor('white'));
var SuggestionsPopup$1 = styled.div(templateObject_6$5 || (templateObject_6$5 = __makeTemplateObject(["\n  position: absolute;\n  background: ", ";\n  max-height: 200px;\n  overflow: auto;\n  z-index: 10;\n  width: 100%;\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  position: absolute;\n  background: ", ";\n  max-height: 200px;\n  overflow: auto;\n  z-index: 10;\n  width: 100%;\n  ", ";\n  ", ";\n  ", ";\n"])), normaliseColor('white'), gapStyle('padding', '4'), shadowStyle('xl'), radiusStyle('lg'));
var SuggestionListItem$1 = styled.li(templateObject_7$4 || (templateObject_7$4 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  cursor: pointer;\n\n  &.suggestion-active {\n    background: ", ";\n    color: ", ";\n  }\n"], ["\n  ", ";\n  ", ";\n  cursor: pointer;\n\n  &.suggestion-active {\n    background: ",
    ";\n    color: ", ";\n  }\n"])), gapStyle('padding', { horizontal: '2', vertical: '2' }), radiusStyle('default'), function (_a) {
    var isGroup = _a.isGroup;
    return isGroup ? normaliseColor('pink-500') : normaliseColor('purple-500');
}, normaliseColor('white'));
var templateObject_1$t, templateObject_2$f, templateObject_3$b, templateObject_4$9, templateObject_5$8, templateObject_6$5, templateObject_7$4;

var TagInput = function (_a) {
    var tags = _a.tags, onChange = _a.onChange, onUnlink = _a.onUnlink, _b = _a.placeholder, placeholder = _b === void 0 ? 'Add new item' : _b, whitelist = _a.whitelist, label = _a.label, addOnBlur = _a.addOnBlur, tagProps = _a.tagProps, _c = _a.addOnPaste, addOnPaste = _c === void 0 ? false : _c, splitAndAddOnPaste = _a.splitAndAddOnPaste;
    var _d = useState(false), focused = _d[0], setFocused = _d[1];
    var _e = useState(false), showSuggestions = _e[0], setShowSuggestions = _e[1];
    var _f = useState(whitelist), filteredSuggestions = _f[0], setFilteredSuggestions = _f[1];
    var _g = useState(0), activeSuggestion = _g[0], setActiveSuggestion = _g[1];
    var _h = useState({
        placeholder: placeholder,
    }), tagInputProperties = _h[0], setTagInputProperties = _h[1];
    var _j = useState({
        className: 'react-tagsinput-tag',
        classNameRemove: 'react-tagsinput-remove',
    }), tagProperties = _j[0], setTagProperties = _j[1];
    var _k = useState(''), tagInputValue = _k[0], setTagInputValue = _k[1];
    var handleFocus = useCallback(function () {
        setFocused(true);
        setActiveSuggestion(0);
    }, []);
    useEffect(function () {
        setShowSuggestions(!!(tagInputValue && whitelist && focused));
    }, [focused, tagInputValue, whitelist]);
    var updateTags = useCallback(function (tagsList) {
        if (whitelist) {
            setFilteredSuggestions(function () {
                return whitelist.filter(function (s) {
                    return !tagsList.some(function (tag) { return tag.id === s.id; });
                });
            });
        }
        onChange(tagsList);
    }, [onChange, whitelist]);
    var canAddNewTag = useCallback(function (existingTags, newTag) {
        var tagExists = existingTags.find(function (tag) {
            return newTag.id ? tag.id === newTag.id : tag.value === newTag.value;
        });
        if (tagExists) {
            return false;
        }
        if (whitelist) {
            return whitelist.find(function (item) { return item.id === newTag.id; });
        }
        return true;
    }, [whitelist]);
    var handlePaste = useCallback(function (e) {
        if (!addOnPaste && !splitAndAddOnPaste) {
            return;
        }
        e.preventDefault();
        var pastedData = e.clipboardData.getData('text/plain');
        var pastedValues = pastedData
            ? splitAndAddOnPaste
                ? splitAndAddOnPaste(pastedData)
                : [pastedData]
            : [];
        var newTags = __spreadArrays(tags);
        var changed = false;
        pastedValues.forEach(function (value) {
            var newTag = whitelist
                ? whitelist
                    .filter(function (whiteListTag) {
                    return !newTags.some(function (existingTag) { return existingTag.id === whiteListTag.id; });
                })
                    .find(function (suggestion) {
                    return suggestion.value.toLowerCase().includes(value.toLowerCase());
                })
                : { value: value };
            if (newTag && canAddNewTag(newTags, newTag)) {
                newTags.push(newTag);
                changed = true;
            }
        });
        if (changed) {
            updateTags(newTags);
        }
    }, [addOnPaste, canAddNewTag, splitAndAddOnPaste, tags, updateTags, whitelist]);
    var handleKeyDown = useCallback(function (e) {
        if (showSuggestions) {
            // User pressed the enter key
            if (e.keyCode === 13) {
                var newTag = filteredSuggestions[activeSuggestion];
                setActiveSuggestion(0);
                if (newTag) {
                    if (canAddNewTag(tags, newTag)) {
                        updateTags(__spreadArrays(tags, [newTag]));
                    }
                }
                setTagInputValue('');
            }
            // User pressed the up arrow
            else if (e.keyCode === 38) {
                if (activeSuggestion <= 0) {
                    return;
                }
                setActiveSuggestion(activeSuggestion - 1);
            }
            // User pressed the down arrow
            else if (e.keyCode === 40) {
                if (activeSuggestion + 1 >= filteredSuggestions.length) {
                    return;
                }
                setActiveSuggestion(activeSuggestion + 1);
            }
        }
        // User pressed the backspace key
        if (e.keyCode === 8) {
            if (!e.currentTarget.value && tags.length) {
                updateTags(tags.slice(0, -1));
            }
        }
    }, [
        showSuggestions,
        filteredSuggestions,
        activeSuggestion,
        canAddNewTag,
        tags,
        updateTags,
    ]);
    var clickSuggestion = useCallback(function (tag) {
        if (canAddNewTag(tags, tag)) {
            updateTags(__spreadArrays(tags, [tag]));
            setTagInputValue('');
        }
    }, [canAddNewTag, tags, updateTags]);
    var hoverSuggestion = useCallback(function (e) { return setActiveSuggestion(~~e.target.dataset.index); }, []);
    var renderTag = useCallback(function (props) {
        var tag = props.tag, key = props.key, disabled = props.disabled, onRemove = props.onRemove, getTagDisplayValue = props.getTagDisplayValue;
        return (React__default.createElement(Tag, { key: key, isGroup: tag.isGroup },
            getTagDisplayValue(tag),
            tag.isGroup && onUnlink && (React__default.createElement(TagUngroup, { onClick: function () { return onUnlink(tag); } },
                React__default.createElement("svg", { viewBox: "0 0 81 81" },
                    React__default.createElement("g", { fillRule: "nonzero" },
                        React__default.createElement("path", { d: "M72.5 53.3l-8-2.7c-2-.6-4.1.6-4.7 2.5-.5 1.9.4 3.9 2.3 4.6l8 2.7c2 .7 4.1-.4 4.7-2.4.6-2-.3-4-2.3-4.7zM52.8 27.7c-1.5-1.5-3.8-1.5-5.3 0L26.3 49c-1.4 1.5-1.3 3.9.2 5.3 1.4 1.3 3.7 1.3 5.1 0L52.8 33c1.4-1.5 1.4-3.8 0-5.3zm3.5 36c-.7-2-2.8-3-4.7-2.4-2 .7-3 2.8-2.4 4.7l2.7 8c.7 2 2.8 3 4.8 2.3 2-.7 3-2.8 2.3-4.8l-2.7-7.8zM22.7 18.3c.6 2 2.7 3.1 4.7 2.5 2-.6 3.1-2.7 2.5-4.7 0-.1-.1-.2-.1-.3l-2.7-8c-.7-2-2.8-3-4.7-2.4-1.9.6-3 2.8-2.4 4.7l2.7 8.2zM6.5 28.6l8 2.7c2 .7 4.1-.4 4.7-2.4.7-2-.4-4.1-2.4-4.7l-8-2.6c-2-.7-4.1.4-4.7 2.4-.6 2 .5 4 2.4 4.6z" }),
                        React__default.createElement("path", { d: "M42.2 22.4l10.6-10.6c4.4-4.4 11.5-4.4 15.9 0s4.4 11.5 0 15.9L58.1 38.3c-1.5 1.4-1.6 3.8-.2 5.3 1.4 1.5 3.8 1.6 5.3.2l.2-.2L74 33c7.6-7 8.2-18.9 1.2-26.5-7-7.6-18.9-8.2-26.5-1.2l-1.2 1.2-10.6 10.6c-1.5 1.4-1.6 3.8-.2 5.3 1.4 1.5 3.8 1.6 5.3.2.1 0 .1-.1.2-.2zM31.6 75.5l10.6-10.6c1.4-1.5 1.3-3.9-.2-5.3-1.4-1.3-3.7-1.3-5.1 0L26.3 70.2c-4.4 4.4-11.5 4.4-15.9 0s-4.4-11.5 0-15.9L21 43.6c1.4-1.5 1.3-3.9-.2-5.3-1.4-1.3-3.7-1.3-5.1 0L5.1 49c-7 7.6-6.4 19.5 1.2 26.5 7.1 6.5 18.1 6.5 25.3 0z" }))))),
            !disabled && (React__default.createElement(TagClose, { isGroup: tag.isGroup, onClick: function () { return onRemove(key); } }, "\u00D7"))));
    }, []);
    useEffect(function () {
        if (tagProps) {
            setTagProperties(function (props) {
                return __assign(__assign({}, props), tagProps);
            });
        }
        if (whitelist) {
            setTagInputProperties(function (props) {
                return __assign(__assign({}, props), { onFocus: handleFocus, onKeyDown: handleKeyDown });
            });
        }
        if (addOnPaste || splitAndAddOnPaste) {
            setTagInputProperties(function (props) {
                return __assign(__assign({}, props), { onPaste: handlePaste });
            });
        }
    }, [
        tagProps,
        setTagProperties,
        setTagInputProperties,
        whitelist,
        handleFocus,
        handleKeyDown,
        splitAndAddOnPaste,
        handlePaste,
        addOnPaste,
    ]);
    var filterSuggestions = useCallback(function () {
        if (tags && whitelist && tagInputValue) {
            setFilteredSuggestions(function () {
                return whitelist
                    .filter(function (s) {
                    return !tags.some(function (e) { return e.id === s.id; });
                })
                    .filter(function (suggestion) {
                    return suggestion.value
                        .toLowerCase()
                        .includes(tagInputValue.toLowerCase());
                });
            });
            setActiveSuggestion(0);
        }
    }, [tagInputValue, tags, whitelist]);
    useEffect(function () {
        if (showSuggestions) {
            filterSuggestions();
        }
        // eslint-disable-next-line
    }, [tags, tagInputValue, showSuggestions]);
    return (React__default.createElement(TagInputWrap, null,
        React__default.createElement(OutsideClickHandler, { onOutsideClick: function () { return setFocused(false); } },
            label && (React__default.createElement(Label, { color: "coolGray-700", weight: "medium", margin: { bottom: '2' } }, label)),
            React__default.createElement(StyledTagInput, { value: tags, inputValue: tagInputValue, onChangeInput: setTagInputValue, onChange: function (newTagList) {
                    updateTags(newTagList);
                }, tagDisplayProp: "value", inputProps: tagInputProperties, addOnBlur: addOnBlur, tagProps: tagProperties, renderTag: renderTag, onlyUnique: true }),
            showSuggestions && filteredSuggestions.length > 0 && (React__default.createElement(SuggestionsPopup$1, null,
                React__default.createElement("ul", null, filteredSuggestions.map(function (source, index) {
                    var className;
                    if (index === activeSuggestion) {
                        className = 'suggestion-active';
                    }
                    return (React__default.createElement(SuggestionListItem$1, { key: source.id, isGroup: source.isGroup, className: className, onClick: function () {
                            clickSuggestion(source);
                        }, onMouseEnter: hoverSuggestion, "data-index": index }, source.value));
                })))))));
};

var StyledTextAreaWrapper = styled.div(templateObject_1$u || (templateObject_1$u = __makeTemplateObject(["\n  position: relative;\n  width: 100%;\n  ", ";\n  max-width: ", "};\n  ", "\n  ", "\n"], ["\n  position: relative;\n  width: 100%;\n  ", ";\n  max-width: ",
    "};\n  ", "\n  ", "\n"])), function (props) { return props.flex && "flex: " + props.flex; }, function (props) {
    return (props.widthProp && props.theme.width[props.widthProp]) ||
        props.widthProp;
}, function (props) { return props.padding && gapStyle('padding', props.padding); }, function (props) { return props.margin && gapStyle('margin', props.margin); });
var StyledTextArea = styled.textarea(templateObject_2$g || (templateObject_2$g = __makeTemplateObject(["\n  width: 100%;\n  outline: none;\n  ", "\n  ", ";\n  color: ", ";\n  font-size: ", ";\n  height: ", ";\n  border: 1px solid;\n  border-color: transparent;\n  ", "\n  box-shadow: 0 0 0 0 transparent;\n  transition: border-color 0.3s ease, box-shadow 0.3s ease;\n  resize: ", ";\n\n  &:focus {\n    box-shadow: 0 0 0 3px ", ";\n    border-color: ", ";\n  }\n\n  &::placeholder {\n    color: ", ";\n  }\n"], ["\n  width: 100%;\n  outline: none;\n  ",
    "\n  ", ";\n  color: ", ";\n  font-size: ", ";\n  height: ", ";\n  border: 1px solid;\n  border-color: transparent;\n  ", "\n  box-shadow: 0 0 0 0 transparent;\n  transition: border-color 0.3s ease, box-shadow 0.3s ease;\n  resize: ", ";\n\n  &:focus {\n    box-shadow: 0 0 0 3px ", ";\n    border-color: ", ";\n  }\n\n  &::placeholder {\n    color: ", ";\n  }\n"])), gapStyle('padding', {
    horizontal: '4',
    vertical: '3',
}), function (props) { return "background: " + normaliseColor(props.background) + ";"; }, normaliseColor('coolGray-700'), function (_a) {
    var theme = _a.theme;
    return theme.fonts.size.base;
}, function (_a) {
    var heightProp = _a.heightProp;
    return heightProp;
}, function (props) { return props.radiusProp && radiusStyle(props.radiusProp); }, function (_a) {
    var resize = _a.resize;
    return resize;
}, normaliseColor('pink-100'), function (props) { return normaliseColor(props.highlight); }, normaliseColor('coolGray-500'));
var templateObject_1$u, templateObject_2$g;

var TextArea = forwardRef(function (_a, _ref) {
    var _b = _a.type, type = _b === void 0 ? 'text' : _b, _c = _a.radius, radius = _c === void 0 ? 'default' : _c, _d = _a.background, background = _d === void 0 ? 'coolGray-100' : _d, label = _a.label, padding = _a.padding, margin = _a.margin, _e = _a.width, width = _e === void 0 ? 'full' : _e, _f = _a.height, height = _f === void 0 ? '100px' : _f, resize = _a.resize, _g = _a.highlight, highlight = _g === void 0 ? 'pink-500' : _g, readOnly = _a.readOnly, onChange = _a.onChange, onClick = _a.onClick, onKeyDown = _a.onKeyDown, onFocus = _a.onFocus, onBlur = _a.onBlur, defaultValue = _a.defaultValue, rest = __rest(_a, ["type", "radius", "background", "label", "padding", "margin", "width", "height", "resize", "highlight", "readOnly", "onChange", "onClick", "onKeyDown", "onFocus", "onBlur", "defaultValue"]);
    return (React__default.createElement(StyledTextAreaWrapper, { padding: padding, margin: margin, widthProp: width },
        label && (React__default.createElement(Label, { color: "coolGray-700", weight: "medium", margin: { bottom: '2' } }, label)),
        React__default.createElement(StyledTextArea, __assign({ type: type, ref: _ref, heightProp: height, background: background, radiusProp: radius, highlight: highlight, resize: resize, readOnly: readOnly, onChange: onChange, onClick: onClick, onKeyDown: onKeyDown, onFocus: onFocus, onBlur: onBlur, defaultValue: defaultValue }, rest))));
});

var StyledTopbar = styled.div(templateObject_1$v || (templateObject_1$v = __makeTemplateObject(["\n  display: flex;\n  width: 100%;\n  background: ", ";\n  ", ";\n  ", "\n  position: sticky;\n  top: 0;\n  z-index: 9;\n"], ["\n  display: flex;\n  width: 100%;\n  background: ", ";\n  ", ";\n  ", "\n  position: sticky;\n  top: 0;\n  z-index: 9;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.white;
}, shadowStyle('default'), gapStyle('padding', { horizontal: '5', vertical: '4' }));
var templateObject_1$v;

var Topbar = function (_a) {
    var children = _a.children;
    return React__default.createElement(StyledTopbar, null, children);
};

/**
 * A hook used to easily manage abort controllers within Function Components.
 * Automatically aborts the current AbortController when the component is unmounted.
 */
var useAutoAbortController = function () {
    var abortController = useRef();
    var current = useCallback(function () {
        return abortController.current;
    }, []);
    var abortCurrent = useCallback(function () {
        var _a;
        (_a = abortController.current) === null || _a === void 0 ? void 0 : _a.abort();
    }, []);
    var abortCurrentAndCreateNew = useCallback(function () {
        var _a;
        (_a = abortController.current) === null || _a === void 0 ? void 0 : _a.abort();
        var controller = new AbortController();
        abortController.current = controller;
        return controller;
    }, []);
    // To ensure the wrapping object does not change
    var autoAbortController = useState({
        current: current,
        abortCurrent: abortCurrent,
        abortCurrentAndCreateNew: abortCurrentAndCreateNew,
    })[0];
    // Abort the current abort controller on unmount
    useEffect(function () {
        return function () {
            var _a;
            (_a = abortController.current) === null || _a === void 0 ? void 0 : _a.abort();
        };
    }, []);
    return autoAbortController;
};

var useFetchAtlas = function (_a) {
    var _b = _a.version, version = _b === void 0 ? '4' : _b, _c = _a.endpoint, endpoint = _c === void 0 ? 'content' : _c, id = _a.id, _d = _a.params, params = _d === void 0 ? {
        annotations: ['description', 'extended_description', 'images'],
    } : _d, options = _a.options, _e = _a.mount, mount = _e === void 0 ? [] : _e, _f = _a.fetchIf, fetchIf = _f === void 0 ? true : _f, _g = _a.batching, batching = _g === void 0 ? false : _g;
    var _h = useState(''), url = _h[0], setUrl = _h[1];
    var _j = useState(false), isLoading = _j[0], setIsLoading = _j[1];
    var _k = useState(null), data = _k[0], setData = _k[1];
    var _l = useState(null), resultCount = _l[0], setResultCount = _l[1];
    var _m = useState(null), error = _m[0], setError = _m[1];
    var selectedApplication = useApplications().selectedApplication;
    var autoAbortController = useAutoAbortController();
    var batchSize = 50;
    var constructUrl = useCallback(function (atlasId) {
        var newUrl = process.env.REACT_APP_ATLAS + "/" + version;
        if (endpoint === 'sherlock') {
            newUrl = newUrl + "/search/content.json?";
        }
        else if (endpoint === 'search') {
            newUrl = newUrl + "/content.json?";
        }
        else {
            if (typeof atlasId === 'string') {
                newUrl = newUrl + "/" + endpoint + "/" + atlasId + ".json?";
            }
            else if (typeof atlasId === 'object') {
                newUrl = newUrl + "/" + endpoint + ".json?id=" + atlasId + "&";
            }
        }
        if (version === '3.0') {
            newUrl = newUrl + "apiKey=" + selectedApplication.api_key;
        }
        else {
            newUrl = newUrl + "key=" + selectedApplication.api_key;
        }
        if (params) {
            newUrl = newUrl + "&" + Object.keys(params)
                .map(function (key) { return key + '=' + params[key]; })
                .join('&');
        }
        if (version === '4' && endpoint !== 'sherlock') {
            // not currently supported in sherlock
            newUrl = newUrl + "&t=" + new Date().getTime();
        }
        return newUrl;
    }, [endpoint, params, selectedApplication.api_key, version]);
    var getDataNamespace = useCallback(function (data) {
        if (data.hasOwnProperty('film')) {
            return 'film';
        }
        else if (data.hasOwnProperty('episode')) {
            return 'episode';
        }
        else if (data.hasOwnProperty('series')) {
            return 'series';
        }
        else if (data.hasOwnProperty('channel')) {
            return 'channel';
        }
        else if (data.hasOwnProperty('content')) {
            return 'content';
        }
        else if (data.hasOwnProperty('brand')) {
            return 'brand';
        }
        else if (data.hasOwnProperty('topics')) {
            return 'topics';
        }
        return 'item';
    }, []);
    var performFetch = useCallback(function (abortController) { return __awaiter(void 0, void 0, void 0, function () {
        var fetchOptions, construcedUrl, error, data_2, i, chunk, res, json, namespace, includedIds, dedupedData, _i, data_1, item, res, json, namespace, error_1, message;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    fetchOptions = __assign(__assign({}, options), { signal: abortController.signal });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 11, 12, 13]);
                    setError(null);
                    setIsLoading(true);
                    construcedUrl = constructUrl(id);
                    setUrl(construcedUrl);
                    if (!(endpoint === 'content' && batching && typeof id === 'object')) return [3 /*break*/, 7];
                    data_2 = [];
                    i = 0;
                    _a.label = 2;
                case 2:
                    if (!(i < id.length)) return [3 /*break*/, 6];
                    chunk = id.slice(i, i + batchSize);
                    return [4 /*yield*/, fetch(constructUrl(chunk), fetchOptions)];
                case 3:
                    res = _a.sent();
                    return [4 /*yield*/, res.json()];
                case 4:
                    json = _a.sent();
                    if (res.status >= 400 && res.status < 600) {
                        error = new Error(res.statusText || res.status.toString());
                        error.message = json;
                        throw error;
                    }
                    namespace = getDataNamespace(json);
                    data_2 = data_2.concat(json[namespace]);
                    _a.label = 5;
                case 5:
                    i += batchSize;
                    return [3 /*break*/, 2];
                case 6:
                    includedIds = new Set();
                    dedupedData = [];
                    for (_i = 0, data_1 = data_2; _i < data_1.length; _i++) {
                        item = data_1[_i];
                        if (!includedIds.has(item.id)) {
                            includedIds.add(item.id);
                            dedupedData.push(item);
                        }
                    }
                    setData(dedupedData);
                    setResultCount(dedupedData.length);
                    return [3 /*break*/, 10];
                case 7: return [4 /*yield*/, fetch(construcedUrl, fetchOptions)];
                case 8:
                    res = _a.sent();
                    return [4 /*yield*/, res.json()];
                case 9:
                    json = _a.sent();
                    if (res.status >= 400 && res.status < 600) {
                        error = new Error(res.statusText || res.status.toString());
                        error.message = json;
                        throw error;
                    }
                    namespace = getDataNamespace(json);
                    setData(json[namespace]);
                    setResultCount(json.results);
                    _a.label = 10;
                case 10: return [3 /*break*/, 13];
                case 11:
                    error_1 = _a.sent();
                    // Only proceed if we haven't aborted the request to start another one otherwise it will lead to inconsistent state
                    if (abortController === autoAbortController.current()) {
                        message = void 0;
                        if (typeof error_1.message === 'string') {
                            message = { message: error_1.message };
                        }
                        else {
                            message = __assign({}, error_1.message);
                        }
                        setData(null);
                        setResultCount(null);
                        setError(message);
                    }
                    return [3 /*break*/, 13];
                case 12:
                    setIsLoading(false);
                    return [7 /*endfinally*/];
                case 13: return [2 /*return*/];
            }
        });
    }); }, [
        autoAbortController,
        constructUrl,
        getDataNamespace,
        options,
        id,
        endpoint,
        batching,
    ]);
    var fetchData = useCallback(function () {
        var controller = autoAbortController.abortCurrentAndCreateNew();
        performFetch(controller);
    }, [autoAbortController, performFetch]);
    useEffect(function () {
        if (fetchIf) {
            fetchData();
        }
        //eslint-disable-next-line
    }, __spreadArrays(mount));
    var abort = useCallback(function () {
        autoAbortController.abortCurrent();
    }, [autoAbortController]);
    return {
        url: url,
        isLoading: isLoading,
        data: data,
        resultCount: resultCount,
        error: error,
        abort: abort,
        refreshData: fetchData,
    };
};

var CountryLanguage = require('country-language');
var useFetchCCIDS = function (_a) {
    var query = _a.query, _b = _a.indexer, indexer = _b === void 0 ? 'barb-content-search' : _b, sort = _a.sort, _c = _a.limit, limit = _c === void 0 ? 1 : _c, _d = _a.offset, offset = _d === void 0 ? 0 : _d, options = _a.options, _e = _a.mount, mount = _e === void 0 ? [] : _e, _f = _a.fetchIf, fetchIf = _f === void 0 ? true : _f;
    var broadcasterGroups = useBroadcasterGroups().broadcasterGroups;
    var _g = useState(false), isLoading = _g[0], setIsLoading = _g[1];
    var _h = useState(null), unformattedData = _h[0], setUnformattedData = _h[1];
    var _j = useState(null), data = _j[0], setData = _j[1];
    var _k = useState(null), resultCount = _k[0], setResultCount = _k[1];
    var _l = useState(null), error = _l[0], setError = _l[1];
    var selectedApplication = useApplications().selectedApplication;
    var autoAbortController = useAutoAbortController();
    var constructUrl = useCallback(function () {
        var url = process.env.REACT_APP_ADMIN_BACKEND + "/1/applications/" + selectedApplication.id + "/" + indexer + "?";
        if (query) {
            url = url + "q=" + query;
        }
        if (sort) {
            url = url + "&sort=" + sort;
        }
        if (limit) {
            url = url + "&limit=" + limit;
        }
        if (offset) {
            url = url + "&offset=" + offset;
        }
        return url;
    }, [limit, offset, query, selectedApplication.id, sort, indexer]);
    var formatResults = useCallback(function () {
        var cleanData = unformattedData.map(function (hit) {
            // convert types
            if (hit._source.contentType === '00') {
                hit._source.contentType = 'version';
            }
            else if (hit._source.contentType === '06') {
                hit._source.contentType = 'episode';
            }
            else if (hit._source.contentType === '07') {
                hit._source.contentType = 'programme';
            }
            if (indexer === 'barb-content-svod-search') {
                if (hit._source.contentType === '08') {
                    hit._source.contentType = 'season';
                }
            }
            // set country
            if (hit._source.countryCode) {
                hit._source.country = CountryLanguage.getCountry(hit._source.countryCode).name;
            }
            hit._source.bgids = hit._source.bgids.map(function (bcid) { var _a; return (_a = broadcasterGroups) === null || _a === void 0 ? void 0 : _a.filter(function (group) { return group.broadcast_group_id === bcid.toString(); })[0]; });
            if (hit._source.aliases) {
                hit._source.aliases = hit._source.aliases.map(function (alias) {
                    var _a;
                    var groupId = (_a = broadcasterGroups) === null || _a === void 0 ? void 0 : _a.filter(function (bg) { return bg.broadcast_group_id === alias.bgId.toString(); });
                    if (groupId && groupId.length) {
                        return __assign(__assign({}, alias), { broadcaster: groupId[0].broadcaster });
                    }
                });
            }
            return hit._source;
        });
        setData(cleanData);
        setIsLoading(false);
    }, [broadcasterGroups, unformattedData, indexer]);
    var performFetch = useCallback(function (abortController) { return __awaiter(void 0, void 0, void 0, function () {
        var fetchOptions, res, json, error, error_1, message;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    fetchOptions = __assign(__assign({}, options), { credentials: 'include', signal: abortController.signal });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    setError(null);
                    setIsLoading(true);
                    return [4 /*yield*/, fetch(constructUrl(), fetchOptions)];
                case 2:
                    res = _a.sent();
                    return [4 /*yield*/, res.json()];
                case 3:
                    json = _a.sent();
                    if (res.status >= 400 && res.status < 600) {
                        error = new Error(res.statusText || res.status.toString());
                        error.message = json;
                        throw error;
                    }
                    setResultCount(json.hits.total);
                    setUnformattedData(json.hits.hits);
                    return [3 /*break*/, 5];
                case 4:
                    error_1 = _a.sent();
                    if (abortController === autoAbortController.current()) {
                        message = void 0;
                        if (typeof error_1.message === 'string') {
                            message = { message: error_1.message };
                        }
                        else {
                            message = __assign({}, error_1.message);
                        }
                        setResultCount(null);
                        setUnformattedData(null);
                        setData(null);
                        setError(message);
                        setIsLoading(false);
                    }
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [autoAbortController, constructUrl, options]);
    var fetchData = useCallback(function () {
        var controller = autoAbortController.abortCurrentAndCreateNew();
        performFetch(controller);
    }, [autoAbortController, performFetch]);
    useEffect(function () {
        if (broadcasterGroups && unformattedData) {
            formatResults();
        }
    }, [broadcasterGroups, formatResults, unformattedData]);
    useEffect(function () {
        if (fetchIf) {
            fetchData();
        }
        //eslint-disable-next-line
    }, __spreadArrays(mount));
    var abort = useCallback(function () {
        autoAbortController.abortCurrent();
    }, [autoAbortController]);
    return {
        isLoading: isLoading,
        data: data,
        resultCount: resultCount,
        error: error,
        abort: abort,
        refreshData: fetchData,
    };
};

var useFetchIndexDate = function (index) {
    var _a = useState(false), isLoading = _a[0], setIsLoading = _a[1];
    var _b = useState(), ccidsDate = _b[0], setCCIDSDate = _b[1];
    var _c = useState(null), error = _c[0], setError = _c[1];
    var selectedApplication = useApplications().selectedApplication;
    var autoAbortController = useAutoAbortController();
    var formatResults = useCallback(function (data) {
        var ccidsIndexName = data.filter(function (esIndex) {
            return esIndex.index.includes(index);
        })[0].index;
        setCCIDSDate(moment(ccidsIndexName.replace(index + "-", '')).calendar('', friendlyDatesNoTime));
    }, [index]);
    var performFetch = useCallback(function (abortController) { return __awaiter(void 0, void 0, void 0, function () {
        var res, json, error, error_1, message;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, 4, 5]);
                    setIsLoading(true);
                    return [4 /*yield*/, fetch(process.env.REACT_APP_ADMIN_BACKEND + "/1/applications/" + selectedApplication.id + "/es-indices", {
                            credentials: 'include',
                            signal: abortController.signal,
                        })];
                case 1:
                    res = _a.sent();
                    return [4 /*yield*/, res.json()];
                case 2:
                    json = _a.sent();
                    if (res.status >= 400 && res.status < 600) {
                        error = new Error(res.statusText || res.status.toString());
                        error.message = json;
                        throw error;
                    }
                    formatResults(json);
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    if (abortController === autoAbortController.current()) {
                        message = void 0;
                        if (typeof error_1.message === 'string') {
                            message = { message: error_1.message };
                        }
                        else {
                            message = __assign({}, error_1.message);
                        }
                        setCCIDSDate(undefined);
                        setError(message);
                    }
                    return [3 /*break*/, 5];
                case 4:
                    setIsLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [autoAbortController, formatResults, selectedApplication.id]);
    var fetchData = useCallback(function () {
        var abortController = autoAbortController.abortCurrentAndCreateNew();
        performFetch(abortController);
    }, [autoAbortController, performFetch]);
    useEffect(function () {
        fetchData();
    }, [fetchData]);
    var abort = useCallback(function () {
        autoAbortController.abortCurrent();
    }, [autoAbortController]);
    return {
        isLoading: isLoading,
        ccidsDate: ccidsDate,
        error: error,
        abort: abort,
    };
};

var useFetchCCIDSDate = function () {
    var _a = useFetchIndexDate('ccidmf'), isLoading = _a.isLoading, ccidsDate = _a.ccidsDate, error = _a.error, abort = _a.abort;
    return {
        isLoading: isLoading,
        ccidsDate: ccidsDate,
        error: error,
        abort: abort,
    };
};

var useFetchCCIDSSFDate = function () {
    var _a = useFetchIndexDate('ccidssf'), isLoading = _a.isLoading, ccidsDate = _a.ccidsDate, error = _a.error, abort = _a.abort;
    return {
        isLoading: isLoading,
        ccidsDate: ccidsDate,
        error: error,
        abort: abort,
    };
};

var alphabet = 'bcdfghjkmnpqrstvwxyz2456789';
var base = alphabet.length;
var useIdCodec = function () {
    var encode = useCallback(function (id) {
        if (id >= 0) {
            var stringBuilder = '';
            if (id === 0) {
                return alphabet[0];
            }
            while (id > 0) {
                stringBuilder += alphabet[id % base];
                id = Math.floor(id / base);
            }
            return stringBuilder
                .split('')
                .reverse()
                .join('')
                .toString();
        }
    }, []);
    var decode = useCallback(function (encodedId) {
        var decoded = 0;
        var encodedIdChars = encodedId.split('');
        encodedIdChars.forEach(function (character) {
            decoded = decoded * base + alphabet.indexOf(character);
        });
        return decoded;
    }, []);
    return {
        encode: encode,
        decode: decode,
    };
};

var useIsCms = function () {
    return useCallback(function (content) {
        var cmsSources = [
            'nitro.bbc.co.uk',
            'cps.itv.com',
            'pmlsd.channel4.com',
            'datasubmission.channel5.com',
            'uktv.co.uk',
        ];
        var equiv = content.same_as.find(function (equiv) {
            return cmsSources.includes(equiv.source);
        });
        if (cmsSources.includes(content.source.key) || equiv) {
            return true;
        }
        else {
            return false;
        }
    }, []);
};

var useIsMounted = function () {
    var isMounted = useRef(false);
    useEffect(function () {
        isMounted.current = true;
        return function () {
            isMounted.current = false;
        };
    }, []);
    return isMounted;
};

var useLocalStorage = function (key, initialValue) {
    // State to store our value
    // Pass initial state function to useState so logic is only executed once
    var _a = useState(function () {
        try {
            // Get from local storage by key
            var item = window.localStorage.getItem(key);
            // Parse stored json or if none return initialValue
            return item ? JSON.parse(item) : initialValue;
        }
        catch (error) {
            // If error also return initialValue
            console.log(error);
            return initialValue;
        }
    }), storedValue = _a[0], setStoredValue = _a[1];
    // Return a wrapped version of useState's setter function that ...
    // ... persists the new value to localStorage.
    var setValue = function (value) {
        try {
            // Allow value to be a function so we have same API as useState
            var valueToStore = value instanceof Function ? value(storedValue) : value;
            // Save state
            setStoredValue(valueToStore);
            // Save to local storage
            window.localStorage.setItem(key, JSON.stringify(valueToStore));
        }
        catch (error) {
            // A more advanced implementation would handle the error case
            console.log(error);
        }
    };
    return [storedValue, setValue];
};

var useQuery = function () {
    return new URLSearchParams(history.location.search);
};

export { A, ApplicationContext, ApplicationProvider, Auth0Context, Auth0Provider, Autocomplete, Box, BoxWrap, BroadcasterGroupsContext, BroadcasterGroupsProvider, Button, ButtonGroup, CachedFetch, Card, Checkbox, Container, DatePicker, DragHandle, Em, ErrorMessage, GenresContext, GenresProvider, GlobalStyles, Heading, HeadingWrap, Label, LoadingSpinner, LoadingSpinnerWrap, Logo, LogoWrap, PageTitle, Pagination, Pill, PrivateRoute, RetryableLoadingSpinner, SelectDropDown, SelectInput, SelectLabel, StationCodesContext, StationCodesProvider, StyledA, StyledButton, StyledButtonGroup, StyledEm, StyledInput, StyledInputWrapper, StyledLabel, StyledPill, StyledPillTitle, StyledPillValue, StyledSelect, StyledSelectWrapper, StyledText, StyledTextArea, StyledTextAreaWrapper, StyledTopbar, TagInput, Text, TextArea, TextInput, Topbar, backgroundStyle, borderStyle, colors$1 as colors, css, dash, devices, fadeIn, friendlyDates, friendlyDatesFullTime, friendlyDatesNoTime, gapStyle, history, normaliseColor, overflowStyle, radiusStyle, resizeImage, rotator, sendNotification, shadowStyle, styled, theme, useApplications, useAuth0, useAutoAbortController, useBroadcasterGroups, useFetchAtlas, useFetchCCIDS, useFetchCCIDSDate, useFetchCCIDSSFDate, useGenres, useIdCodec, useIsCms, useIsMounted, useLocalStorage, useQuery, useStationCodes, weightStyle };
